(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'react', 'react-dom', 'styled-components'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('react'), require('react-dom'), require('styled-components'));
  else {
    if (typeof react === 'undefined') {
      throw new Error("Error loading module 'scansioniser'. Its dependency 'react' was not found. Please, check whether 'react' is loaded prior to 'scansioniser'.");
    }if (typeof this['react-dom'] === 'undefined') {
      throw new Error("Error loading module 'scansioniser'. Its dependency 'react-dom' was not found. Please, check whether 'react-dom' is loaded prior to 'scansioniser'.");
    }if (typeof this['styled-components'] === 'undefined') {
      throw new Error("Error loading module 'scansioniser'. Its dependency 'styled-components' was not found. Please, check whether 'styled-components' is loaded prior to 'scansioniser'.");
    }root.scansioniser = factory(typeof scansioniser === 'undefined' ? {} : scansioniser, react, this['react-dom'], this['styled-components']);
  }
}(this, function (_, $module$react, $module$react_dom, $module$styled_components) {
  var createElement = $module$react.createElement;
  var Component = $module$react.Component;
  var Children = $module$react.Children;
  var Fragment = $module$react.Fragment;
  var render = $module$react_dom.render;
  var createGlobalStyle = $module$styled_components.createGlobalStyle;
  'use strict';
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  SubList.prototype = Object.create(AbstractMutableList.prototype);
  SubList.prototype.constructor = SubList;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  _no_name_provided__7.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__7.prototype.constructor = _no_name_provided__7;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  EntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractMutableSet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  _no_name_provided__35.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__35.prototype.constructor = _no_name_provided__35;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  RElementBuilder.prototype = Object.create(RBuilder.prototype);
  RElementBuilder.prototype.constructor = RElementBuilder;
  RComponent.prototype = Object.create(Component.prototype);
  RComponent.prototype.constructor = RComponent;
  StringAttribute.prototype = Object.create(Attribute.prototype);
  StringAttribute.prototype.constructor = StringAttribute;
  StringSetAttribute.prototype = Object.create(Attribute.prototype);
  StringSetAttribute.prototype.constructor = StringSetAttribute;
  EnumAttribute.prototype = Object.create(Attribute.prototype);
  EnumAttribute.prototype.constructor = EnumAttribute;
  InputType.prototype = Object.create(Enum.prototype);
  InputType.prototype.constructor = InputType;
  DIV.prototype = Object.create(HTMLTag.prototype);
  DIV.prototype.constructor = DIV;
  FIELDSET.prototype = Object.create(HTMLTag.prototype);
  FIELDSET.prototype.constructor = FIELDSET;
  INPUT.prototype = Object.create(HTMLTag.prototype);
  INPUT.prototype.constructor = INPUT;
  LEGEND.prototype = Object.create(HTMLTag.prototype);
  LEGEND.prototype.constructor = LEGEND;
  LABEL.prototype = Object.create(HTMLTag.prototype);
  LABEL.prototype.constructor = LABEL;
  RDOMBuilder.prototype = Object.create(RBuilder.prototype);
  RDOMBuilder.prototype.constructor = RDOMBuilder;
  Stress.prototype = Object.create(Enum.prototype);
  Stress.prototype.constructor = Stress;
  Foot.prototype = Object.create(Enum.prototype);
  Foot.prototype.constructor = Foot;
  Meter.prototype = Object.create(Enum.prototype);
  Meter.prototype.constructor = Meter;
  ScansioniserUI.prototype = Object.create(RComponent.prototype);
  ScansioniserUI.prototype.constructor = ScansioniserUI;
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    var separator_0 = !(($mask0 & 1) === 0) ? ', ' : separator;
    var prefix_0 = !(($mask0 & 2) === 0) ? '' : prefix;
    var postfix_0 = !(($mask0 & 4) === 0) ? '' : postfix;
    var limit_0 = !(($mask0 & 8) === 0) ? -1 : limit;
    var truncated_0 = !(($mask0 & 16) === 0) ? '...' : truncated;
    var transform_0 = !(($mask0 & 32) === 0) ? null : transform;
    return joinToString(_this_, separator_0, prefix_0, postfix_0, limit_0, truncated_0, transform_0);
  }
  function asSequence(_this_) {
    if (_this_.length === 0)
      return emptySequence();
    else {
    }
    return new _no_name_provided__1(_this_);
  }
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this_.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function toSet(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_[0]);
      default:return toCollection(_this_, LinkedHashSet_init_$Create$_0(mapCapacity(_this_.length)));
    }
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_18(item);
      Unit_getInstance();
    }
    return destination;
  }
  function _no_name_provided__1($this) {
    this._$this = $this;
  }
  _no_name_provided__1.prototype.iterator_2_0 = function () {
    return arrayIterator(this._$this);
  };
  _no_name_provided__1.prototype.iterator_42 = function () {
    return this.iterator_2_0();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    var separator_0 = !(($mask0 & 1) === 0) ? ', ' : separator;
    var prefix_0 = !(($mask0 & 2) === 0) ? '' : prefix;
    var postfix_0 = !(($mask0 & 4) === 0) ? '' : postfix;
    var limit_0 = !(($mask0 & 8) === 0) ? -1 : limit;
    var truncated_0 = !(($mask0 & 16) === 0) ? '...' : truncated;
    var transform_0 = !(($mask0 & 32) === 0) ? null : transform;
    return joinToString_0(_this_, separator_0, prefix_0, postfix_0, limit_0, truncated_0, transform_0);
  }
  function toSet_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__29();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_38(0);
          } else {
            {
              tmp_0 = _this_.iterator_42().next_14();
            }
          }

          tmp = setOf_0(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_0(mapCapacity(_this_._get_size__29())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function zip(_this_, other) {
    var first_1 = _this_.iterator_42();
    var second_2 = other.iterator_42();
    var tmp0_minOf_0 = collectionSizeOrDefault(_this_, 10);
    var tmp1_minOf_0 = collectionSizeOrDefault(other, 10);
    var list_3 = ArrayList_init_$Create$_0(function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0, tmp1_minOf_0]))));
    }.call(this));
    while (first_1.hasNext_12() ? second_2.hasNext_12() : false) {
      var tmp2__anonymous__4 = first_1.next_14();
      var tmp3__anonymous__4 = second_2.next_14();
      list_3.add_18(to(tmp2__anonymous__4, tmp3__anonymous__4));
      Unit_getInstance();
    }
    return list_3;
  }
  function reversed(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__29() <= 1;
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return toList_0(_this_);
    else {
    }
    var list = toMutableList_0(_this_);
    reverse(list);
    return list;
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var item = tmp0_iterator.next_14();
      destination.add_18(item);
      Unit_getInstance();
    }
    return destination;
  }
  function sortedWith(_this_, comparator) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__29() <= 1)
        return toList_0(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith_0(tmp1_apply_0, comparator);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_0(_this_);
    sortWith(tmp2_apply_0, comparator);
    return tmp2_apply_0;
  }
  function toList_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__29();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_38(0);
          } else {
            {
              tmp_0 = _this_.iterator_42().next_14();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList_1(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_0(_this_));
  }
  function toMutableList_0(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList_1(_this_);
    else {
    }
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function toMutableList_1(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function asSequence_0(_this_) {
    return new _no_name_provided__1_0(_this_);
  }
  function first(_this_) {
    if (_this_.isEmpty_28())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_38(0);
  }
  function _no_name_provided__1_0($this) {
    this._$this_0 = $this;
  }
  _no_name_provided__1_0.prototype.iterator_2_0 = function () {
    return this._$this_0.iterator_42();
  };
  _no_name_provided__1_0.prototype.iterator_42 = function () {
    return this.iterator_2_0();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function toMutableList_2(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function filterNot(_this_, predicate) {
    return new FilteringSequence(_this_, false, predicate);
  }
  function firstOrNull(_this_) {
    var iterator = _this_.iterator_42();
    if (!iterator.hasNext_12())
      return null;
    return iterator.next_14();
  }
  function filter(_this_, predicate) {
    return new FilteringSequence(_this_, true, predicate);
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this_, DropTakeSequence)) {
        tmp = _this_.take_1(n);
      } else {
        {
          tmp = new TakeSequence(_this_, n);
        }
      }
    }
    return tmp;
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var item = tmp0_iterator.next_14();
      destination.add_18(item);
      Unit_getInstance();
    }
    return destination;
  }
  function plus(_this_, element) {
    var result = LinkedHashSet_init_$Create$_0(mapCapacity(_this_._get_size__29() + 1 | 0));
    result.addAll_10(_this_);
    Unit_getInstance();
    result.add_18(element);
    Unit_getInstance();
    return result;
  }
  function toMutableList_3(_this_) {
    return toCollection_2(_this_, ArrayList_init_$Create$_0(charSequenceLength(_this_)));
  }
  function toCollection_2(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var item = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_18(item);
      Unit_getInstance();
    }
    return destination;
  }
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_29 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_28();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (equals(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_22 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_28();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.contains_29(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_28 = function () {
    return this._get_size__29() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory($this) {
    var i = new _no_name_provided_($this);
    return function (p1) {
      return i.invoke(p1);
    };
  }
  function _no_name_provided_($this) {
    this._$this_1 = $this;
  }
  _no_name_provided_.prototype.invoke = function (it) {
    return it === this._$this_1 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_105 = function (p1) {
    return this.invoke((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size) {
    if (index < 0 ? true : index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size) {
    if (index < 0 ? true : index > size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.checkRangeIndexes = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 ? true : toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var e = tmp0_iterator.next_14();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__29() === other._get_size__29()))
      return false;
    var otherIterator = other.iterator_42();
    var tmp0_iterator = c.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var elem = tmp0_iterator.next_14();
      var elemOther = otherIterator.next_14();
      if (!equals(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function AbstractMap() {
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_9 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsEntry_2 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__3();
    var value = entry._get_value__3();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_26(key);
    if (!equals(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_9(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__29() === other._get_size__29()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__7();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_28();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.containsEntry_2(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_26 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__7());
  };
  AbstractMap.prototype.isEmpty_28 = function () {
    return this._get_size__29() === 0;
  };
  AbstractMap.prototype._get_size__29 = function () {
    return this._get_entries__7()._get_size__29();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__7();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__3()) + '=' + toString(this, entry._get_value__3());
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0($this) {
    var i = new _no_name_provided__0($this);
    return function (p1) {
      return i.invoke_1(p1);
    };
  }
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__7();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (equals(element_2._get_key__3(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__3();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__3();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__3() + '=' + e._get_value__3();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals(e._get_key__3(), other._get_key__3()) ? equals(e._get_value__3(), other._get_value__3()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__0($this) {
    this._$this_2 = $this;
  }
  _no_name_provided__0.prototype.invoke_1 = function (it) {
    return this._$this_2.toString_0(it);
  };
  _no_name_provided__0.prototype.invoke_105 = function (p1) {
    return this.invoke_1((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__29() === other._get_size__29()))
      return false;
    return c.containsAll_22(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function _get_lastIndex__0(_this_) {
    return _this_._get_size__29() - 1 | 0;
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__29();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_38(0));
      default:return _this_;
    }
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_28();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__29 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_28 = function () {
    return true;
  };
  EmptyList.prototype.contains_5 = function (element) {
    return false;
  };
  EmptyList.prototype.contains_29 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_5(tmp);
  };
  EmptyList.prototype.containsAll_4 = function (elements) {
    return elements.isEmpty_28();
  };
  EmptyList.prototype.containsAll_22 = function (elements) {
    return this.containsAll_4(elements);
  };
  EmptyList.prototype.get_38 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_42 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.subList_5 = function (fromIndex, toIndex) {
    if (fromIndex === 0 ? toIndex === 0 : false)
      return this;
    throw IndexOutOfBoundsException_init_$Create$('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_12 = function () {
    return false;
  };
  EmptyIterator.prototype.next_14 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function _get_indices_(_this_) {
    return numberRangeToNumber(0, _this_._get_size__29() - 1 | 0);
  }
  function ArrayAsCollection(values_2, isVarargs) {
    this._values = values_2;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__29 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_28 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_3 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.contains_29 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_3((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_2 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_28();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.contains_3(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_22 = function (elements) {
    return this.containsAll_2(elements);
  };
  ArrayAsCollection.prototype.iterator_42 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__29();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function toMutableMap(_this_) {
    return LinkedHashMap_init_$Create$_2(_this_);
  }
  function toMap(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__29();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_38(0);
          } else {
            {
              tmp_0 = _this_.iterator_42().next_14();
            }
          }

          tmp = mapOf(tmp_0);
          break;
        default:tmp = toMap_0(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_._get_size__29())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyMap(toMap_0(_this_, LinkedHashMap_init_$Create$()));
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_28();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__29 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_28 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_9 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_0((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_2 = function (key) {
    return null;
  };
  EmptyMap.prototype.get_26 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_2((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__7 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function toMap_0(_this_, destination) {
    putAll_0(destination, _this_);
    return destination;
  }
  function optimizeReadOnlyMap(_this_) {
    var tmp0_subject = _this_._get_size__29();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = _this_;
        break;
      default:tmp = _this_;
        break;
    }
    return tmp;
  }
  function putAll(_this_, pairs) {
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.component1();
      var value = tmp1_loop_parameter.component2();
      _this_.put_7(key, value);
      Unit_getInstance();
    }
  }
  function putAll_0(_this_, pairs) {
    var tmp0_iterator = pairs.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var tmp1_loop_parameter = tmp0_iterator.next_14();
      var key = tmp1_loop_parameter.component1();
      var value = tmp1_loop_parameter.component2();
      _this_.put_7(key, value);
      Unit_getInstance();
    }
  }
  function hashMapOf(pairs) {
    var tmp0_apply_0 = HashMap_init_$Create$_1(mapCapacity(pairs.length));
    putAll(tmp0_apply_0, pairs);
    return tmp0_apply_0;
  }
  function addAll(_this_, elements) {
    var result = false;
    var tmp0_iterator = elements.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var item = tmp0_iterator.next_14();
      if (_this_.add_18(item))
        result = true;
    }
    return result;
  }
  function addAll_0(_this_, elements) {
    return _this_.addAll_10(asList(elements));
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function emptySequence() {
    return EmptySequence_getInstance();
  }
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function TransformingSequence(sequence, transformer) {
    this._sequence = sequence;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_42 = function () {
    return new _no_name_provided__2(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function FilteringSequence(sequence, sendWhen, predicate) {
    this._sequence_0 = sequence;
    this._sendWhen = sendWhen;
    this._predicate = predicate;
  }
  FilteringSequence.prototype.iterator_42 = function () {
    return new _no_name_provided__3(this);
  };
  FilteringSequence.$metadata$ = {
    simpleName: 'FilteringSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function DropTakeSequence() {
  }
  DropTakeSequence.$metadata$ = {
    simpleName: 'DropTakeSequence',
    kind: 'interface',
    interfaces: [Sequence]
  };
  function TakeSequence(sequence, count) {
    this._sequence_1 = sequence;
    this._count = count;
    var tmp0_require_0 = this._count >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'count must be non-negative, but was ' + this._count + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  TakeSequence.prototype.take_1 = function (n) {
    return n >= this._count ? this : new TakeSequence(this._sequence_1, n);
  };
  TakeSequence.prototype.iterator_42 = function () {
    return new _no_name_provided__4(this);
  };
  TakeSequence.$metadata$ = {
    simpleName: 'TakeSequence',
    kind: 'class',
    interfaces: [Sequence, DropTakeSequence]
  };
  function EmptySequence() {
    EmptySequence_instance = this;
  }
  EmptySequence.prototype.iterator_42 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySequence.prototype.take_1 = function (n) {
    return EmptySequence_getInstance();
  };
  EmptySequence.$metadata$ = {
    simpleName: 'EmptySequence',
    kind: 'object',
    interfaces: [Sequence, DropTakeSequence]
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    if (EmptySequence_instance == null)
      new EmptySequence();
    return EmptySequence_instance;
  }
  function GeneratorSequence(getInitialValue, getNextValue) {
    this._getInitialValue = getInitialValue;
    this._getNextValue = getNextValue;
  }
  GeneratorSequence.prototype.iterator_42 = function () {
    return new _no_name_provided__5(this);
  };
  GeneratorSequence.$metadata$ = {
    simpleName: 'GeneratorSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function _no_name_provided__2($this) {
    this._$this_3 = $this;
    this._iterator = this._$this_3._sequence.iterator_42();
  }
  _no_name_provided__2.prototype.next_14 = function () {
    return this._$this_3._transformer(this._iterator.next_14());
  };
  _no_name_provided__2.prototype.hasNext_12 = function () {
    return this._iterator.hasNext_12();
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function calcNext($this) {
    while ($this._iterator_0.hasNext_12()) {
      var item = $this._iterator_0.next_14();
      if ($this._$this_4._predicate(item) === $this._$this_4._sendWhen) {
        $this._nextItem = item;
        $this._nextState = 1;
        return Unit_getInstance();
      }}
    $this._nextState = 0;
  }
  function _no_name_provided__3($this) {
    this._$this_4 = $this;
    this._iterator_0 = this._$this_4._sequence_0.iterator_42();
    this._nextState = -1;
    this._nextItem = null;
  }
  _no_name_provided__3.prototype.next_14 = function () {
    if (this._nextState === -1)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var result = this._nextItem;
    this._nextItem = null;
    this._nextState = -1;
    return (result == null ? true : isObject(result)) ? result : THROW_CCE();
  };
  _no_name_provided__3.prototype.hasNext_12 = function () {
    if (this._nextState === -1)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__4($this) {
    this._$this_5 = $this;
    this._left = this._$this_5._count;
    this._iterator_1 = this._$this_5._sequence_1.iterator_42();
  }
  _no_name_provided__4.prototype.next_14 = function () {
    if (this._left === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._left;
    tmp0_this._left = tmp1 - 1 | 0;
    Unit_getInstance();
    return this._iterator_1.next_14();
  };
  _no_name_provided__4.prototype.hasNext_12 = function () {
    return this._left > 0 ? this._iterator_1.hasNext_12() : false;
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function calcNext_0($this) {
    $this._nextItem_0 = $this._nextState_0 === -2 ? $this._$this_6._getInitialValue() : $this._$this_6._getNextValue(ensureNotNull($this._nextItem_0));
    $this._nextState_0 = $this._nextItem_0 == null ? 0 : 1;
  }
  function _no_name_provided__5($this) {
    this._$this_6 = $this;
    this._nextItem_0 = null;
    this._nextState_0 = -2;
  }
  _no_name_provided__5.prototype.next_14 = function () {
    if (this._nextState_0 < 0)
      calcNext_0(this);
    if (this._nextState_0 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_0;
    var result = isObject(tmp) ? tmp : THROW_CCE();
    this._nextState_0 = -1;
    return result;
  };
  _no_name_provided__5.prototype.hasNext_12 = function () {
    if (this._nextState_0 < 0)
      calcNext_0(this);
    return this._nextState_0 === 1;
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function emptySet() {
    return EmptySet_getInstance();
  }
  function setOf(elements) {
    return elements.length > 0 ? toSet(elements) : emptySet();
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__29();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_.iterator_42().next_14());
      default:return _this_;
    }
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_28();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__29 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_28 = function () {
    return true;
  };
  EmptySet.prototype.contains_5 = function (element) {
    return false;
  };
  EmptySet.prototype.contains_29 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_5(tmp);
  };
  EmptySet.prototype.containsAll_4 = function (elements) {
    return elements.isEmpty_28();
  };
  EmptySet.prototype.containsAll_22 = function (elements) {
    return this.containsAll_4(elements);
  };
  EmptySet.prototype.iterator_42 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$(mapCapacity(elements.length)));
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function _get_lastIndex__1(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Pair(first_0, second) {
    this._first = first_0;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1 = function () {
    return this._first;
  };
  Pair.prototype.component2 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    return imul(this._first == null ? 0 : hashCode(this._first), 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_14 = function () {
    return this.nextInt_0();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first_0, last, step) {
    IntIterator.call(this);
    this._step = step;
    this._finalElement = last;
    this._hasNext = this._step > 0 ? first_0 <= last : first_0 >= last;
    this._next = this._hasNext ? first_0 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_12 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_0 = function () {
    var value = this._next;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next = tmp0_this._next + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function IntProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step === IntCompanionObject_getInstance()._MIN_VALUE)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start;
    this._last = getProgressionLastElement(start, endInclusive, step);
    this._step_0 = step;
  }
  IntProgression.prototype._get_first__0 = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__0 = function () {
    return this._last;
  };
  IntProgression.prototype._get_step__0 = function () {
    return this._step_0;
  };
  IntProgression.prototype.iterator_42 = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_0);
  };
  IntProgression.prototype.isEmpty_28 = function () {
    return this._step_0 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_28() ? other.isEmpty_28() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_0 === other._step_0 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_28() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_0 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_0 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_0 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_0 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function IntRange(start, endInclusive) {
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start_ = function () {
    return this._get_first__0();
  };
  IntRange.prototype._get_endInclusive_ = function () {
    return this._get_last__0();
  };
  IntRange.prototype.contains_7 = function (value) {
    return this._get_first__0() <= value ? value <= this._get_last__0() : false;
  };
  IntRange.prototype.isEmpty_28 = function () {
    return this._get_first__0() > this._get_last__0();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_28() ? other.isEmpty_28() : false) ? true : this._get_first__0() === other._get_first__0() ? this._get_last__0() === other._get_last__0() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_28() ? -1 : imul(31, this._get_first__0()) + this._get_last__0() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0() + '..' + this._get_last__0();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE = -2147483648;
    this._MAX_VALUE = 2147483647;
    this._SIZE_BYTES = 4;
    this._SIZE_BITS = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE_ = function () {
    return this._MIN_VALUE;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE_ = function () {
    return this._MAX_VALUE;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES_ = function () {
    return this._SIZE_BYTES;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS_ = function () {
    return this._SIZE_BITS;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS_
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function setOf_0(element) {
    return hashSetOf([element]);
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function mapOf(pair) {
    return hashMapOf([pair]);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__29() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var untilArg = array.length;
    var inductionVariable = 0;
    var last = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_3(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable <= last);
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator = collection.iterator_42();
    while (iterator.hasNext_12()) {
      array.push(iterator.next_14());
    }
    return array;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.addAll_10 = function (elements) {
    this.checkIsMutable_11();
    var modified = false;
    var tmp0_iterator = elements.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      if (this.add_18(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_18 = function (element) {
    this.checkIsMutable_11();
    this.add_17(this._get_size__29(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_42 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_29 = function (element) {
    return this.indexOf_1(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_1 = function (element) {
    var inductionVariable = 0;
    var last = _get_lastIndex__0(this);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.get_38(index), element)) {
          return index;
        }}
       while (!(index === last));
    return -1;
  };
  AbstractMutableList.prototype.subList_5 = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function IteratorImpl($outer) {
    this._$this_7 = $outer;
    this._index = 0;
    this._last_0 = -1;
  }
  IteratorImpl.prototype.hasNext_12 = function () {
    return this._index < this._$this_7._get_size__29();
  };
  IteratorImpl.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    tmp._last_0 = tmp1;
    return this._$this_7.get_38(this._last_0);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SubList(list, fromIndex, toIndex) {
    AbstractMutableList.call(this);
    this._list = list;
    this._fromIndex = fromIndex;
    this.__size = 0;
    Companion_getInstance().checkRangeIndexes(this._fromIndex, toIndex, this._list._get_size__29());
    this.__size = toIndex - this._fromIndex | 0;
  }
  SubList.prototype.add_17 = function (index, element) {
    Companion_getInstance().checkPositionIndex(index, this.__size);
    this._list.add_17(this._fromIndex + index | 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size;
    tmp0_this.__size = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  SubList.prototype.get_38 = function (index) {
    Companion_getInstance().checkElementIndex(index, this.__size);
    return this._list.get_38(this._fromIndex + index | 0);
  };
  SubList.prototype.set_3 = function (index, element) {
    Companion_getInstance().checkElementIndex(index, this.__size);
    return this._list.set_3(this._fromIndex + index | 0, element);
  };
  SubList.prototype._get_size__29 = function () {
    return this.__size;
  };
  SubList.prototype.checkIsMutable_11 = function () {
    return this._list.checkIsMutable_11();
  };
  SubList.$metadata$ = {
    simpleName: 'SubList',
    kind: 'class',
    interfaces: [RandomAccess]
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__1 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__7(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_0 = function (from) {
    this.checkIsMutable_11();
    var tmp0_iterator = from._get_entries__7().iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var tmp1_loop_parameter = tmp0_iterator.next_14();
      var key = tmp1_loop_parameter._get_key__3();
      var value = tmp1_loop_parameter._get_value__3();
      this.put_7(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function _no_name_provided__6($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__6.prototype.hasNext_12 = function () {
    return this._$entryIterator.hasNext_12();
  };
  _no_name_provided__6.prototype.next_14 = function () {
    return this._$entryIterator.next_14()._get_key__3();
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key = key;
    this.__value = value;
  }
  SimpleEntry.prototype._get_key__3 = function () {
    return this._key;
  };
  SimpleEntry.prototype._get_value__3 = function () {
    return this.__value;
  };
  SimpleEntry.prototype.setValue_1 = function (newValue) {
    var oldValue = this.__value;
    this.__value = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function _no_name_provided__7($this) {
    this._$this_8 = $this;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__7.prototype.add_5 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__7.prototype.add_18 = function (element) {
    return this.add_5((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype.contains_19 = function (element) {
    return this._$this_8.containsKey_9(element);
  };
  _no_name_provided__7.prototype.contains_29 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_19((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype.iterator_42 = function () {
    var entryIterator = this._$this_8._get_entries__7().iterator_42();
    return new _no_name_provided__6(entryIterator);
  };
  _no_name_provided__7.prototype._get_size__29 = function () {
    return this._$this_8._get_size__29();
  };
  _no_name_provided__7.prototype.checkIsMutable_11 = function () {
    return this._$this_8.checkIsMutable_11();
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__29 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_38 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_3 = function (index, element) {
    this.checkIsMutable_11();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array[index];
    this._array[index] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_18 = function (element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_17 = function (index, element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_10 = function (elements) {
    this.checkIsMutable_11();
    if (elements.isEmpty_28())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0();
    tmp1_this._set_modCount__0(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.indexOf_1 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_0 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0();
  };
  ArrayList.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__29());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__29());
    return index;
  }
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_1(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    var last = 599;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index);
      }
       while (inductionVariable <= last);
    var comparison = _no_name_provided_$factory_2();
    array.sort(comparison);
    var untilArg = array.length;
    var inductionVariable_0 = 1;
    var last_0 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable_0 <= last_0 : false)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 <= last_0);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      var last = endInclusive;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === last));
    }}
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    var last = end;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end : false) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === last));
    return target;
  }
  function _no_name_provided__8($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__8.prototype.invoke_3 = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__8.prototype.invoke_69 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_3(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__9() {
  }
  _no_name_provided__9.prototype.invoke_5 = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__9.prototype.invoke_69 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_5(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_1($comparator) {
    var i = new _no_name_provided__8($comparator);
    return function (p1, p2) {
      return i.invoke_3(p1, p2);
    };
  }
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__9();
    return function (p1, p2) {
      return i.invoke_5(p1, p2);
    };
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  HashMap.prototype.containsKey_9 = function (key) {
    return this._internalMap.contains_19(key);
  };
  HashMap.prototype._get_entries__7 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_26 = function (key) {
    return this._internalMap.get_26(key);
  };
  HashMap.prototype.put_7 = function (key, value) {
    return this._internalMap.put_7(key, value);
  };
  HashMap.prototype._get_size__29 = function () {
    return this._internalMap._get_size__29();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function EntrySet($outer) {
    this._$this_9 = $outer;
    AbstractMutableSet.call(this);
  }
  EntrySet.prototype.add_13 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_18 = function (element) {
    return this.add_13((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.contains_20 = function (element) {
    return this._$this_9.containsEntry_2(element);
  };
  EntrySet.prototype.contains_29 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_20((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.iterator_42 = function () {
    return this._$this_9._internalMap.iterator_42();
  };
  EntrySet.prototype._get_size__29 = function () {
    return this._$this_9._get_size__29();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_1(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, Object.create(HashMap.prototype));
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_18 = function (element) {
    var old = this._map.put_7(element, this);
    return old == null;
  };
  HashSet.prototype.contains_29 = function (element) {
    return this._map.containsKey_9(element);
  };
  HashSet.prototype.isEmpty_28 = function () {
    return this._map.isEmpty_28();
  };
  HashSet.prototype.iterator_42 = function () {
    return this._map._get_keys__1().iterator_42();
  };
  HashSet.prototype._get_size__29 = function () {
    return this._map._get_size__29();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function HashSet_init_$Init$(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_0(initialCapacity, $this) {
    HashSet_init_$Init$(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$(initialCapacity) {
    return HashSet_init_$Init$_0(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__29 = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_7 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__3(), key)) {
          return entry.setValue_1(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_1(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.contains_19 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_26 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  InternalHashCodeMap.prototype.iterator_42 = function () {
    return new _no_name_provided__10(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._$this_10._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__3(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__3(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__10($this) {
    this._$this_10 = $this;
    this._state = -1;
    this._keys = Object.keys(this._$this_10._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__10.prototype.hasNext_12 = function () {
    if (this._state === -1)
      this._state = computeNext(this);
    return this._state === 0;
  };
  _no_name_provided__10.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state = -1;
    return lastEntry;
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  LinkedHashMap.prototype.containsKey_9 = function (key) {
    return this._map_0.containsKey_9(key);
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_26 = function (key) {
    var tmp0_safe_receiver = this._map_0.get_26(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  LinkedHashMap.prototype.put_7 = function (key, value) {
    this.checkIsMutable_11();
    var old = this._map_0.get_26(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_7(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_1(value);
    }
  };
  LinkedHashMap.prototype._get_size__29 = function () {
    return this._map_0._get_size__29();
  };
  LinkedHashMap.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function EntryIterator($outer) {
    this._$this_11 = $outer;
    this._last_1 = null;
    this._next_0 = null;
    this._next_0 = this._$this_11._$this_13._head;
  }
  EntryIterator.prototype.hasNext_12 = function () {
    return !(this._next_0 === null);
  };
  EntryIterator.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_0);
    this._last_1 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_1;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_11._$this_13._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_0 = tmp_0;
    return current;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_12 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_1 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_1 = function (newValue) {
    this._$this_12.checkIsMutable_11();
    return SimpleEntry.prototype.setValue_1.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_13 = $outer;
    AbstractMutableSet.call(this);
  }
  EntrySet_0.prototype.add_13 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_18 = function (element) {
    return this.add_13((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.contains_20 = function (element) {
    return this._$this_13.containsEntry_2(element);
  };
  EntrySet_0.prototype.contains_29 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_20((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.iterator_42 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype._get_size__29 = function () {
    return this._$this_13._get_size__29();
  };
  EntrySet_0.prototype.checkIsMutable_11 = function () {
    return this._$this_13.checkIsMutable_11();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_1 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_1 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_1 = _head;
      _head._prev = _this_;
      _tail._next_1 = _this_;
    }
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_0(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_11 = function () {
    return this._get_map__0().checkIsMutable_11();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(initialCapacity) {
    return LinkedHashSet_init_$Init$_1(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__2();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__2();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__2 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  var functionClasses;
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_3());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_4());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_5());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_6());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_7());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_8());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_9());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_10());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_11());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_12());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_13());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_14());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_15());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_16());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_17());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_18());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_19());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_20());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_21());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_22(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_3() {
    var i = new _no_name_provided__11();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_4() {
    var i = new _no_name_provided__12();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__14();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__15();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__16();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__17();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__19();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__21();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__27();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_22($arity) {
    var i = new _no_name_provided__30($arity);
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function _no_name_provided__11() {
  }
  _no_name_provided__11.prototype.invoke_52 = function (it) {
    return isObject(it);
  };
  _no_name_provided__11.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__12() {
  }
  _no_name_provided__12.prototype.invoke_52 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__12.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__13.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14() {
  }
  _no_name_provided__14.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__14.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15() {
  }
  _no_name_provided__15.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__15.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__16.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__17.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__18.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19() {
  }
  _no_name_provided__19.prototype.invoke_52 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__19.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_52 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__20.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21() {
  }
  _no_name_provided__21.prototype.invoke_52 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__21.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_52 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__22.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_52 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__23.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_52 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__24.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_52 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__25.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_52 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__26.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27() {
  }
  _no_name_provided__27.prototype.invoke_52 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__27.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_52 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__28.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_52 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__29.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__30.prototype.invoke_52 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__30.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_38 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__1(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', length: ' + this._get_length__0() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function StringBuilder_init_$Init$($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$() {
    return StringBuilder_init_$Init$(Object.create(StringBuilder.prototype));
  }
  function Regex(pattern, options) {
    this._pattern = pattern;
    this._options = toSet_0(options);
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(options, 10));
    var tmp0_iterator_1_2 = options.iterator_42();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var item_2_3 = tmp0_iterator_1_2.next_14();
      tmp0_mapTo_0_1.add_18(item_2_3.value__error);
      Unit_getInstance();
    }
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null) + 'g');
  }
  Regex.prototype.find = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.findAll = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }var tmp = _no_name_provided_$factory_23(this, input, startIndex);
    return generateSequence(tmp, _no_name_provided_$factory_24());
  };
  Regex.prototype.findAll$default = function (input, startIndex, $mask0, $handler) {
    var startIndex_0 = !(($mask0 & 2) === 0) ? 0 : startIndex;
    return this.findAll(input, startIndex_0);
  };
  Regex.prototype.split = function (input, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_let_0 = this.findAll$default(input, 0, 2, null);
    var matches = limit === 0 ? tmp1_let_0 : take(tmp1_let_0, limit - 1 | 0);
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var tmp0_iterator = matches.iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var match = tmp0_iterator.next_14();
      result.add_18(toString_1(charSequenceSubSequence(input, lastStart, match._get_range__0()._get_start_())));
      Unit_getInstance();
      lastStart = match._get_range__0()._get_endInclusive_() + 1 | 0;
    }
    result.add_18(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    Unit_getInstance();
    return result;
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  function MatchGroup(value) {
    this._value = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value === tmp0_other_with_cast._value))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__31(range, match, _this_, input);
  }
  function _no_name_provided__31($range, $match, $this, $input) {
    this._$range = $range;
    this._$match = $match;
    this._$this_14 = $this;
    this._$input = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__35(this._$match);
    this._groupValues_ = null;
  }
  _no_name_provided__31.prototype._get_range__0 = function () {
    return this._range;
  };
  _no_name_provided__31.prototype.next_14 = function () {
    return findNext(this._$this_14, this._$input, this._$range.isEmpty_28() ? this._$range._get_start_() + 1 | 0 : this._$range._get_endInclusive_() + 1 | 0);
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function _no_name_provided_$factory_23($this, $input, $startIndex) {
    var i = new _no_name_provided__32($this, $input, $startIndex);
    return function () {
      return i.invoke_61();
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__33();
    return function (p1) {
      return i.invoke_66(p1);
    };
  }
  function _no_name_provided_$factory_25($this) {
    var i = new _no_name_provided__34($this);
    return function (p1) {
      return i.invoke_50(p1);
    };
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, Object.create(Regex.prototype));
  }
  function Companion_3() {
    Companion_instance_2 = this;
    this._patternEscape = new RegExp('[-\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_3.prototype.escape = function (literal) {
    var tmp0_nativeReplace_0 = this._patternEscape;
    var tmp1_nativeReplace_0 = '\\$&';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function _no_name_provided__32($this, $input, $startIndex) {
    this._$this_15 = $this;
    this._$input_0 = $input;
    this._$startIndex = $startIndex;
  }
  _no_name_provided__32.prototype.invoke_61 = function () {
    return this._$this_15.find(this._$input_0, this._$startIndex);
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_66 = function (match) {
    return match.next_14();
  };
  _no_name_provided__33.prototype.invoke_105 = function (p1) {
    return this.invoke_66((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34($this) {
    this._$this_16 = $this;
  }
  _no_name_provided__34.prototype.invoke_50 = function (it) {
    return this._$this_16.get_38(it);
  };
  _no_name_provided__34.prototype.invoke_105 = function (p1) {
    return this.invoke_50((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35($match) {
    this._$match_0 = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__35.prototype._get_size__29 = function () {
    return this._$match_0.length;
  };
  _no_name_provided__35.prototype.iterator_42 = function () {
    var tmp = asSequence_0(_get_indices_(this));
    return map(tmp, _no_name_provided_$factory_25(this)).iterator_42();
  };
  _no_name_provided__35.prototype.get_38 = function (index) {
    var tmp0_safe_receiver = this._$match_0[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function capitalize(_this_) {
    var tmp;
    if (charSequenceLength(_this_) > 0) {
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = 1;
      var tmp2_toUpperCase_0 = _this_.substring(tmp0_substring_0, tmp1_substring_0);
      var tmp_0 = tmp2_toUpperCase_0.toUpperCase();
      var tmp3_substring_0 = 1;
      tmp = tmp_0 + _this_.substring(tmp3_substring_0);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function replace(_this_, oldChar, newChar, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_2().escape(oldChar.toString()), ignoreCase ? 'gi' : 'g');
    var tmp1_nativeReplace_0 = newChar.toString();
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default(_this_, oldChar, newChar, ignoreCase, $mask0, $handler) {
    var ignoreCase_0 = !(($mask0 & 4) === 0) ? false : ignoreCase;
    return replace(_this_, oldChar, newChar, ignoreCase_0);
  }
  function Char(value) {
    this._value_0 = value;
  }
  Char.prototype.compareTo_0 = function (other) {
    return this._value_0 - other._value_0 | 0;
  };
  Char.prototype.compareTo_5 = function (other) {
    return this.compareTo_0(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_0 === other._value_0;
  };
  Char.prototype.hashCode = function () {
    return this._value_0;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_0);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function Enum(name, ordinal) {
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_name__0 = function () {
    return this._name;
  };
  Enum.prototype.compareTo_2 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_5 = function (other) {
    return this.compareTo_2(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__36(array);
  }
  function _no_name_provided__36($array) {
    this._$array = $array;
    this._index_0 = 0;
  }
  _no_name_provided__36.prototype.hasNext_12 = function () {
    return !(this._index_0 === this._$array.length);
  };
  _no_name_provided__36.prototype.next_14 = function () {
    var tmp;
    if (!(this._index_0 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_0;
      tmp0_this._index_0 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_0);
    }
    return tmp;
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      tmp = new Char(tmp0_unsafeCast_0);
    } else {
      tmp = a.get_38(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_26(), 24, null);
  }
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_52 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__37.prototype.invoke_105 = function (p1) {
    return this.invoke_52((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__37();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_5(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp1_elvis_lhs = message;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        var tmp0_safe_receiver = cause;
        tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      this_.message = tmp2_elvis_lhs == null ? undefined : tmp2_elvis_lhs;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function Long(low, high) {
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_38 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_5 = function (other) {
    return this.compareTo_38(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_27 = function (other) {
    return add(this, other);
  };
  Long.prototype.div_27 = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_27(new Long(1, 0));
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_4 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_27(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_27(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_27(negate(other));
      } else {
        tmp = negate(negate(_this_).div_27(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_27(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_27(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_4();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_27(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_4();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_4();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return ((type === 'string' ? true : type === 'boolean') ? true : isNumber(value)) ? true : isInterface(value, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function sortWith_0(_this_, comparator) {
    if (_this_.length > 1)
      sortArrayWith(_this_, comparator);
  }
  function reverse(_this_) {
    var midPoint = (_this_._get_size__29() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_getInstance();
    var reverseIndex = _get_lastIndex__0(_this_);
    var inductionVariable = 0;
    var last = midPoint;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this_.get_38(index);
        _this_.set_3(index, _this_.get_38(reverseIndex));
        Unit_getInstance();
        _this_.set_3(reverseIndex, tmp);
        Unit_getInstance();
        var tmp1 = reverseIndex;
        reverseIndex = tmp1 - 1 | 0;
        Unit_getInstance();
      }
       while (!(index === last));
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, null, null);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, null);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function RBuilder() {
    var tmp = this;
    tmp._childList = ArrayList_init_$Create$();
  }
  RBuilder.prototype._get_childList__1 = function () {
    return this._childList;
  };
  RBuilder.prototype.child_7 = function (element) {
    this._childList.add_18(element);
    Unit_getInstance();
    return element;
  };
  RBuilder.prototype.unaryPlus_0 = function (_this__0) {
    this._childList.add_18(_this__0);
    Unit_getInstance();
  };
  RBuilder.prototype.child_8 = function (type, props, children) {
    return this.child_7(createElement.apply(null, [].concat([type], [props], [].slice.call(copyToArray_0(children).slice()))));
  };
  RBuilder.prototype.child_9 = function (type, props, handler) {
    var tmp0_with_0 = new RElementBuilder(props);
    handler(tmp0_with_0);
    var children = tmp0_with_0._get_childList__1();
    return this.child_8(type, props, children);
  };
  RBuilder.prototype.invoke_59 = function (_this__0, handler) {
    return this.child_9(_this__0, {}, handler);
  };
  RBuilder.prototype.child_10 = function (klazz, handler) {
    return this.invoke_59(_get_rClass_(klazz), handler);
  };
  RBuilder.prototype.children_6 = function (_this__0) {
    addAll_0(this._childList, Children.toArray(_get_children_(_this__0)));
    Unit_getInstance();
  };
  RBuilder.prototype.children_7 = function (_this__0, value) {
    var tmp = _get_children_(_this__0);
    this._childList.add_18((typeof tmp === 'function' ? tmp : THROW_CCE())(value));
    Unit_getInstance();
  };
  RBuilder.$metadata$ = {
    simpleName: 'RBuilder',
    kind: 'class',
    interfaces: []
  };
  function RElementBuilder(attrs) {
    RBuilder.call(this);
    this._attrs = attrs;
  }
  RElementBuilder.prototype._get_attrs_ = function () {
    return this._attrs;
  };
  RElementBuilder.prototype.attrs_0 = function (handler) {
    handler(this._get_attrs_());
  };
  RElementBuilder.$metadata$ = {
    simpleName: 'RElementBuilder',
    kind: 'class',
    interfaces: []
  };
  function buildElements(handler) {
    var tmp0_apply_0 = new RBuilder();
    handler(tmp0_apply_0);
    var nodes = tmp0_apply_0._childList;
    var tmp0_subject = nodes._get_size__29();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = null;
        break;
      case 1:
        tmp = first(nodes);
        break;
      default:var tmp_0 = Fragment;
        var tmp0_apply_0_1 = {};
        Unit_getInstance();
        tmp = createElement.apply(null, [].concat([tmp_0], [tmp0_apply_0_1], [].slice.call(copyToArray_0(nodes).slice())));
        break;
    }
    return tmp;
  }
  function _get_rClass_(_this_) {
    var tmp0_unsafeCast_0 = _get_js_(_this_);
    return tmp0_unsafeCast_0;
  }
  RComponent.prototype.init = function (_this__0) {
  };
  RComponent.prototype.init_0 = function (_this__0, props) {
  };
  RComponent.prototype.children_8 = function (_this__0) {
    _this__0.children_6(this.props);
  };
  RComponent.prototype.children_9 = function (_this__0, value) {
    _this__0.children_7(this.props, value);
  };
  RComponent.prototype.render_3 = function () {
    return buildElements(_no_name_provided_$factory_27(this));
  };
  RComponent.prototype.render = function () {
    return this.render_3();
  };
  function RComponent() {
  }
  RComponent.$metadata$ = {
    simpleName: 'RComponent',
    kind: 'class',
    interfaces: []
  };
  function _get_children_(_this_) {
    return _this_.children;
  }
  function _no_name_provided_$factory_27($this) {
    var i = new _no_name_provided__38($this);
    return function (p1) {
      i.invoke_82(p1);
      return Unit_getInstance();
    };
  }
  function RComponent_init_$Init$(props, $this) {
    Component.call($this, props);
    RComponent.call($this);
    var tmp0_apply_0_1 = {};
    $this.init_0(tmp0_apply_0_1, props);
    $this.state = tmp0_apply_0_1;
    return $this;
  }
  function _no_name_provided__38($this) {
    this._$this_17 = $this;
  }
  _no_name_provided__38.prototype.invoke_82 = function (_this__0) {
    this._$this_17.render_2(_this__0);
  };
  _no_name_provided__38.prototype.invoke_105 = function (p1) {
    this.invoke_82(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var emptyMap_0;
  function AttributeEnum() {
  }
  AttributeEnum.$metadata$ = {
    simpleName: 'AttributeEnum',
    kind: 'interface',
    interfaces: []
  };
  function Tag() {
  }
  Tag.$metadata$ = {
    simpleName: 'Tag',
    kind: 'interface',
    interfaces: []
  };
  function TagConsumer() {
  }
  TagConsumer.$metadata$ = {
    simpleName: 'TagConsumer',
    kind: 'interface',
    interfaces: []
  };
  function attributesMapOf(key, value) {
    var tmp0_subject = value;
    return tmp0_subject == null ? emptyMap_0 : singletonMapOf(key, value);
  }
  function attributesMapOf_0(pairs) {
    var result = null;
    var nestedLast = pairs.length - 1 | 0;
    var inductionVariable = 0;
    var last = getProgressionLastElement(0, nestedLast, 2);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        var k = pairs[i];
        var v = pairs[i + 1 | 0];
        if (!(k == null) ? !(v == null) : false) {
          if (result == null) {
            result = LinkedHashMap_init_$Create$();
          }result.put_7(k, v);
          Unit_getInstance();
        }}
       while (!(i === last));
    var tmp1_elvis_lhs = result;
    return tmp1_elvis_lhs == null ? emptyMap_0 : tmp1_elvis_lhs;
  }
  function singletonMapOf(key, value) {
    return new SingletonStringMap(key, value);
  }
  function SingletonStringMap(key, value) {
    this._key_0 = key;
    this._value_1 = value;
  }
  SingletonStringMap.prototype._get_key__3 = function () {
    return this._key_0;
  };
  SingletonStringMap.prototype._get_value__3 = function () {
    return this._value_1;
  };
  SingletonStringMap.prototype._get_entries__7 = function () {
    return setOf_0(this);
  };
  SingletonStringMap.prototype._get_size__29 = function () {
    return 1;
  };
  SingletonStringMap.prototype.containsKey_8 = function (key) {
    return key === this._key_0;
  };
  SingletonStringMap.prototype.containsKey_9 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_8((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.get_25 = function (key) {
    return key === this._key_0 ? this._value_1 : null;
  };
  SingletonStringMap.prototype.get_26 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_25((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.isEmpty_28 = function () {
    return false;
  };
  SingletonStringMap.prototype.toString = function () {
    return '' + 'SingletonStringMap(key=' + this._key_0 + ', value=' + this._value_1 + ')';
  };
  SingletonStringMap.prototype.hashCode = function () {
    return imul(getStringHashCode(this._key_0), 31) + getStringHashCode(this._value_1) | 0;
  };
  SingletonStringMap.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SingletonStringMap))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SingletonStringMap ? other : THROW_CCE();
    if (!(this._key_0 === tmp0_other_with_cast._key_0))
      return false;
    if (!(this._value_1 === tmp0_other_with_cast._value_1))
      return false;
    return true;
  };
  SingletonStringMap.$metadata$ = {
    simpleName: 'SingletonStringMap',
    kind: 'class',
    interfaces: [Map_0, Entry]
  };
  function Attribute(encoder) {
    this._encoder = encoder;
  }
  Attribute.prototype.get_24 = function (thisRef, attributeName) {
    var tmp0_safe_receiver = thisRef._get_attributes__5().get_26(attributeName);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = this._encoder.decode_2(attributeName, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this._encoder.empty_2(attributeName, thisRef) : tmp1_elvis_lhs;
  };
  Attribute.prototype.set_7 = function (thisRef, attributeName, value) {
    thisRef._get_attributes__5().put_7(attributeName, this._encoder.encode_4(attributeName, value));
    Unit_getInstance();
  };
  Attribute.$metadata$ = {
    simpleName: 'Attribute',
    kind: 'class',
    interfaces: []
  };
  function StringAttribute() {
    Attribute.call(this, StringEncoder_getInstance());
  }
  StringAttribute.$metadata$ = {
    simpleName: 'StringAttribute',
    kind: 'class',
    interfaces: []
  };
  function StringSetAttribute() {
    Attribute.call(this, StringSetEncoder_getInstance());
  }
  StringSetAttribute.$metadata$ = {
    simpleName: 'StringSetAttribute',
    kind: 'class',
    interfaces: []
  };
  function EnumAttribute(values_2) {
    Attribute.call(this, new EnumEncoder(values_2));
    this._values_0 = values_2;
  }
  EnumAttribute.$metadata$ = {
    simpleName: 'EnumAttribute',
    kind: 'class',
    interfaces: []
  };
  function AttributeEncoder() {
  }
  AttributeEncoder.prototype.empty_2 = function (attributeName, tag) {
    throw IllegalStateException_init_$Create$_0('' + 'Attribute ' + attributeName + ' is not yet defined for tag ' + tag._get_tagName__5());
  };
  AttributeEncoder.$metadata$ = {
    simpleName: 'AttributeEncoder',
    kind: 'interface',
    interfaces: []
  };
  function StringEncoder() {
    StringEncoder_instance = this;
  }
  StringEncoder.prototype.encode_0 = function (attributeName, value) {
    return value;
  };
  StringEncoder.prototype.encode_4 = function (attributeName, value) {
    return this.encode_0(attributeName, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  StringEncoder.prototype.decode_2 = function (attributeName, value) {
    return value;
  };
  StringEncoder.$metadata$ = {
    simpleName: 'StringEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var StringEncoder_instance;
  function StringEncoder_getInstance() {
    if (StringEncoder_instance == null)
      new StringEncoder();
    return StringEncoder_instance;
  }
  function StringSetEncoder() {
    StringSetEncoder_instance = this;
  }
  StringSetEncoder.prototype.encode_2 = function (attributeName, value) {
    return joinToString$default_0(value, ' ', null, null, 0, null, null, 62, null);
  };
  StringSetEncoder.prototype.encode_4 = function (attributeName, value) {
    return this.encode_2(attributeName, (!(value == null) ? isInterface(value, Set) : false) ? value : THROW_CCE());
  };
  StringSetEncoder.prototype.decode_2 = function (attributeName, value) {
    return ensureNotNull(stringSetDecode(value));
  };
  StringSetEncoder.prototype.empty_2 = function (attributeName, tag) {
    return emptySet();
  };
  StringSetEncoder.$metadata$ = {
    simpleName: 'StringSetEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var StringSetEncoder_instance;
  function StringSetEncoder_getInstance() {
    if (StringSetEncoder_instance == null)
      new StringSetEncoder();
    return StringSetEncoder_instance;
  }
  function EnumEncoder(valuesMap) {
    this._valuesMap = valuesMap;
  }
  EnumEncoder.prototype.encode_4 = function (attributeName, value) {
    return value._get_realValue__0();
  };
  EnumEncoder.prototype.decode_2 = function (attributeName, value) {
    var tmp0_elvis_lhs = this._valuesMap.get_26(value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('' + 'Unknown value ' + value + ' for ' + attributeName);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  EnumEncoder.$metadata$ = {
    simpleName: 'EnumEncoder',
    kind: 'class',
    interfaces: [AttributeEncoder]
  };
  function stringSetDecode(value) {
    var tmp0_safe_receiver = value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_toRegex_0 = '\\s+';
      var tmp1_split_0 = Regex_init_$Create$(tmp0_toRegex_0);
      var tmp2_split_0 = 0;
      tmp = tmp1_split_0.split(tmp0_safe_receiver, tmp2_split_0);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_filterNotTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp1_safe_receiver.iterator_42();
      while (tmp0_iterator_1_2.hasNext_12()) {
        var element_2_3 = tmp0_iterator_1_2.next_14();
        if (!(charSequenceLength(element_2_3) === 0)) {
          tmp0_filterNotTo_0_1.add_18(element_2_3);
          Unit_getInstance();
        } else {
        }
      }
      tmp_0 = tmp0_filterNotTo_0_1;
    }
    var tmp2_safe_receiver = tmp_0;
    return tmp2_safe_receiver == null ? null : toSet_0(tmp2_safe_receiver);
  }
  function enumEncode(_this_) {
    return _this_._get_realValue__0();
  }
  function DelegatingMap(initialValues, tag, consumer) {
    this._tag = tag;
    this._consumer = consumer;
    this._backing = initialValues;
    this._backingMutable = false;
  }
  DelegatingMap.prototype._get_size__29 = function () {
    return this._backing._get_size__29();
  };
  DelegatingMap.prototype.isEmpty_28 = function () {
    return this._backing.isEmpty_28();
  };
  DelegatingMap.prototype.containsKey_8 = function (key) {
    return this._backing.containsKey_9(key);
  };
  DelegatingMap.prototype.containsKey_9 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_8((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.get_25 = function (key) {
    return this._backing.get_26(key);
  };
  DelegatingMap.prototype.get_26 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_25((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.put_6 = function (key, value) {
    var mutable = switchToMutable(this);
    var old = mutable.put_7(key, value);
    if (!(old === value)) {
      this._consumer().onTagAttributeChange_0(this._tag, key, value);
    }return old;
  };
  DelegatingMap.prototype.put_7 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_6(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  DelegatingMap.prototype._get_immutableEntries_ = function () {
    return this._backing._get_entries__7();
  };
  DelegatingMap.prototype._get_entries__7 = function () {
    return switchToMutable(this)._get_entries__7();
  };
  DelegatingMap.$metadata$ = {
    simpleName: 'DelegatingMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function switchToMutable($this) {
    var tmp;
    if ($this._backingMutable) {
      tmp = $this._backing;
    } else {
      $this._backingMutable = true;
      $this._backing = LinkedHashMap_init_$Create$_2($this._backing);
      tmp = $this._backing;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, MutableMap) ? tmp_0 : THROW_CCE();
  }
  function _set_id_(_this_, newValue) {
    attributeStringString.set_7(_this_, 'id', newValue);
  }
  function _set_classes_(_this_, newValue) {
    attributeSetStringStringSet.set_7(_this_, 'class', newValue);
  }
  function _get_classes_(_this_) {
    return attributeSetStringStringSet.get_24(_this_, 'class');
  }
  function CommonAttributeGroupFacade() {
  }
  CommonAttributeGroupFacade.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacade',
    kind: 'interface',
    interfaces: [Tag]
  };
  var attributeStringString;
  var attributeSetStringStringSet;
  var attributeInputTypeEnumInputTypeValues;
  var inputTypeValues;
  function InputType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this._realValue = realValue;
  }
  InputType.prototype._get_realValue__0 = function () {
    return this._realValue;
  };
  InputType.$metadata$ = {
    simpleName: 'InputType',
    kind: 'class',
    interfaces: [AttributeEnum]
  };
  function InputType_button_getInstance() {
    InputType_initEntries();
    return InputType_button_instance;
  }
  function InputType_checkBox_getInstance() {
    InputType_initEntries();
    return InputType_checkBox_instance;
  }
  function InputType_color_getInstance() {
    InputType_initEntries();
    return InputType_color_instance;
  }
  function InputType_date_getInstance() {
    InputType_initEntries();
    return InputType_date_instance;
  }
  function InputType_dateTime_getInstance() {
    InputType_initEntries();
    return InputType_dateTime_instance;
  }
  function InputType_dateTimeLocal_getInstance() {
    InputType_initEntries();
    return InputType_dateTimeLocal_instance;
  }
  function InputType_email_getInstance() {
    InputType_initEntries();
    return InputType_email_instance;
  }
  function InputType_file_getInstance() {
    InputType_initEntries();
    return InputType_file_instance;
  }
  function InputType_hidden_getInstance() {
    InputType_initEntries();
    return InputType_hidden_instance;
  }
  function InputType_image_getInstance() {
    InputType_initEntries();
    return InputType_image_instance;
  }
  function InputType_month_getInstance() {
    InputType_initEntries();
    return InputType_month_instance;
  }
  function InputType_number_getInstance() {
    InputType_initEntries();
    return InputType_number_instance;
  }
  function InputType_password_getInstance() {
    InputType_initEntries();
    return InputType_password_instance;
  }
  function InputType_radio_getInstance() {
    InputType_initEntries();
    return InputType_radio_instance;
  }
  function InputType_range_getInstance() {
    InputType_initEntries();
    return InputType_range_instance;
  }
  function InputType_reset_getInstance() {
    InputType_initEntries();
    return InputType_reset_instance;
  }
  function InputType_search_getInstance() {
    InputType_initEntries();
    return InputType_search_instance;
  }
  function InputType_submit_getInstance() {
    InputType_initEntries();
    return InputType_submit_instance;
  }
  function InputType_text_getInstance() {
    InputType_initEntries();
    return InputType_text_instance;
  }
  function InputType_tel_getInstance() {
    InputType_initEntries();
    return InputType_tel_instance;
  }
  function InputType_time_getInstance() {
    InputType_initEntries();
    return InputType_time_instance;
  }
  function InputType_url_getInstance() {
    InputType_initEntries();
    return InputType_url_instance;
  }
  function InputType_week_getInstance() {
    InputType_initEntries();
    return InputType_week_instance;
  }
  function inputTypeValues$init$() {
    var tmp0_associateBy_0 = values();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_7(element_2_4._realValue, element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  }
  var InputType_button_instance;
  var InputType_checkBox_instance;
  var InputType_color_instance;
  var InputType_date_instance;
  var InputType_dateTime_instance;
  var InputType_dateTimeLocal_instance;
  var InputType_email_instance;
  var InputType_file_instance;
  var InputType_hidden_instance;
  var InputType_image_instance;
  var InputType_month_instance;
  var InputType_number_instance;
  var InputType_password_instance;
  var InputType_radio_instance;
  var InputType_range_instance;
  var InputType_reset_instance;
  var InputType_search_instance;
  var InputType_submit_instance;
  var InputType_text_instance;
  var InputType_tel_instance;
  var InputType_time_instance;
  var InputType_url_instance;
  var InputType_week_instance;
  function values() {
    return [InputType_button_getInstance(), InputType_checkBox_getInstance(), InputType_color_getInstance(), InputType_date_getInstance(), InputType_dateTime_getInstance(), InputType_dateTimeLocal_getInstance(), InputType_email_getInstance(), InputType_file_getInstance(), InputType_hidden_getInstance(), InputType_image_getInstance(), InputType_month_getInstance(), InputType_number_getInstance(), InputType_password_getInstance(), InputType_radio_getInstance(), InputType_range_getInstance(), InputType_reset_getInstance(), InputType_search_getInstance(), InputType_submit_getInstance(), InputType_text_getInstance(), InputType_tel_getInstance(), InputType_time_getInstance(), InputType_url_getInstance(), InputType_week_getInstance()];
  }
  var InputType_entriesInitialized;
  function InputType_initEntries() {
    if (InputType_entriesInitialized)
      return Unit_getInstance();
    InputType_entriesInitialized = true;
    InputType_button_instance = new InputType('button', 0, 'button');
    InputType_checkBox_instance = new InputType('checkBox', 1, 'checkbox');
    InputType_color_instance = new InputType('color', 2, 'color');
    InputType_date_instance = new InputType('date', 3, 'date');
    InputType_dateTime_instance = new InputType('dateTime', 4, 'datetime');
    InputType_dateTimeLocal_instance = new InputType('dateTimeLocal', 5, 'datetime-local');
    InputType_email_instance = new InputType('email', 6, 'email');
    InputType_file_instance = new InputType('file', 7, 'file');
    InputType_hidden_instance = new InputType('hidden', 8, 'hidden');
    InputType_image_instance = new InputType('image', 9, 'image');
    InputType_month_instance = new InputType('month', 10, 'month');
    InputType_number_instance = new InputType('number', 11, 'number');
    InputType_password_instance = new InputType('password', 12, 'password');
    InputType_radio_instance = new InputType('radio', 13, 'radio');
    InputType_range_instance = new InputType('range', 14, 'range');
    InputType_reset_instance = new InputType('reset', 15, 'reset');
    InputType_search_instance = new InputType('search', 16, 'search');
    InputType_submit_instance = new InputType('submit', 17, 'submit');
    InputType_text_instance = new InputType('text', 18, 'text');
    InputType_tel_instance = new InputType('tel', 19, 'tel');
    InputType_time_instance = new InputType('time', 20, 'time');
    InputType_url_instance = new InputType('url', 21, 'url');
    InputType_week_instance = new InputType('week', 22, 'week');
  }
  function CommonAttributeGroupFacadeFlowInteractivePhrasingContent() {
  }
  CommonAttributeGroupFacadeFlowInteractivePhrasingContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractivePhrasingContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, CommonAttributeGroupFacadeFlowInteractiveContent, FlowPhrasingContent, HtmlBlockInlineTag, HtmlBlockTag, HtmlInlineTag]
  };
  function HtmlBlockTag() {
  }
  HtmlBlockTag.$metadata$ = {
    simpleName: 'HtmlBlockTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowContent]
  };
  function HtmlBlockInlineTag() {
  }
  HtmlBlockInlineTag.$metadata$ = {
    simpleName: 'HtmlBlockInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowPhrasingContent, HtmlBlockTag, HtmlInlineTag]
  };
  function CommonAttributeGroupFacadeFlowInteractiveContent() {
  }
  CommonAttributeGroupFacadeFlowInteractiveContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractiveContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, HtmlBlockTag, InteractiveContent]
  };
  function FlowPhrasingContent() {
  }
  FlowPhrasingContent.$metadata$ = {
    simpleName: 'FlowPhrasingContent',
    kind: 'interface',
    interfaces: [FlowContent, PhrasingContent]
  };
  function HtmlInlineTag() {
  }
  HtmlInlineTag.$metadata$ = {
    simpleName: 'HtmlInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, PhrasingContent]
  };
  function FlowContent() {
  }
  FlowContent.$metadata$ = {
    simpleName: 'FlowContent',
    kind: 'interface',
    interfaces: [FlowOrHeadingContent, FlowOrMetaDataContent, FlowOrInteractiveContent, FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, SectioningOrFlowContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function InteractiveContent() {
  }
  InteractiveContent.$metadata$ = {
    simpleName: 'InteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function PhrasingContent() {
  }
  PhrasingContent.$metadata$ = {
    simpleName: 'PhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrHeadingContent() {
  }
  FlowOrHeadingContent.$metadata$ = {
    simpleName: 'FlowOrHeadingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrMetaDataContent() {
  }
  FlowOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrMetaDataContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrInteractiveContent() {
  }
  FlowOrInteractiveContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrPhrasingContent() {
  }
  FlowOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrPhrasingOrMetaDataContent() {
  }
  FlowOrPhrasingOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingOrMetaDataContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function SectioningOrFlowContent() {
  }
  SectioningOrFlowContent.$metadata$ = {
    simpleName: 'SectioningOrFlowContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrInteractiveOrPhrasingContent() {
  }
  FlowOrInteractiveOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveOrPhrasingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function DIV(initialAttributes, consumer) {
    HTMLTag.call(this, 'div', consumer, initialAttributes, null, false, false);
    this._consumer_0 = consumer;
  }
  DIV.prototype._get_consumer__5 = function () {
    return this._consumer_0;
  };
  DIV.$metadata$ = {
    simpleName: 'DIV',
    kind: 'class',
    interfaces: [HtmlBlockTag]
  };
  function FIELDSET(initialAttributes, consumer) {
    HTMLTag.call(this, 'fieldset', consumer, initialAttributes, null, false, false);
    this._consumer_1 = consumer;
  }
  FIELDSET.prototype._get_consumer__5 = function () {
    return this._consumer_1;
  };
  FIELDSET.$metadata$ = {
    simpleName: 'FIELDSET',
    kind: 'class',
    interfaces: [HtmlBlockTag]
  };
  function INPUT(initialAttributes, consumer) {
    HTMLTag.call(this, 'input', consumer, initialAttributes, null, true, true);
    this._consumer_2 = consumer;
  }
  INPUT.prototype._get_consumer__5 = function () {
    return this._consumer_2;
  };
  INPUT.prototype._set_type_ = function (newValue) {
    attributeInputTypeEnumInputTypeValues.set_7(this, 'type', newValue);
  };
  INPUT.prototype._set_value_ = function (newValue) {
    attributeStringString.set_7(this, 'value', newValue);
  };
  INPUT.prototype._set_name_ = function (newValue) {
    attributeStringString.set_7(this, 'name', newValue);
  };
  INPUT.$metadata$ = {
    simpleName: 'INPUT',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function LEGEND(initialAttributes, consumer) {
    HTMLTag.call(this, 'legend', consumer, initialAttributes, null, true, false);
    this._consumer_3 = consumer;
  }
  LEGEND.prototype._get_consumer__5 = function () {
    return this._consumer_3;
  };
  LEGEND.$metadata$ = {
    simpleName: 'LEGEND',
    kind: 'class',
    interfaces: [HtmlBlockInlineTag]
  };
  function LABEL(initialAttributes, consumer) {
    HTMLTag.call(this, 'label', consumer, initialAttributes, null, true, false);
    this._consumer_4 = consumer;
  }
  LABEL.prototype._get_consumer__5 = function () {
    return this._consumer_4;
  };
  LABEL.$metadata$ = {
    simpleName: 'LABEL',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function HTMLTag(tagName, consumer, initialAttributes, namespace, inlineTag, emptyTag) {
    this._tagName = tagName;
    this._consumer_5 = consumer;
    this._namespace = namespace;
    this._inlineTag = inlineTag;
    this._emptyTag = emptyTag;
    var tmp = this;
    tmp._attributes = new DelegatingMap(initialAttributes, this, _no_name_provided_$factory_28(this));
  }
  HTMLTag.prototype._get_tagName__5 = function () {
    return this._tagName;
  };
  HTMLTag.prototype._get_consumer__5 = function () {
    return this._consumer_5;
  };
  HTMLTag.prototype._get_attributes__5 = function () {
    return this._attributes;
  };
  HTMLTag.prototype._get_attributesEntries__5 = function () {
    return this._get_attributes__5()._get_immutableEntries_();
  };
  HTMLTag.$metadata$ = {
    simpleName: 'HTMLTag',
    kind: 'class',
    interfaces: [Tag]
  };
  function _no_name_provided_$factory_28($this) {
    var i = new _no_name_provided__39($this);
    return function () {
      return i.invoke_61();
    };
  }
  function _no_name_provided__39($this) {
    this._$this_18 = $this;
  }
  _no_name_provided__39.prototype.invoke_61 = function () {
    return this._$this_18._get_consumer__5();
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _set_onChangeFunction_(_this_, newValue) {
    _this_._get_consumer__5().onTagEvent_0(_this_, 'onchange', newValue);
  }
  function RDOMBuilder(factory) {
    RBuilder.call(this);
    var tmp = this;
    tmp._consumer_6 = new _no_name_provided__40(this);
    this._attrs_0 = factory(this._consumer_6);
    var tmp_0 = this;
    tmp_0._props = {};
    var tmp0_forEach_0 = this._attrs_0._get_attributesEntries__5();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_42();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      this.setProp(element_2._get_key__3(), element_2._get_value__3());
    }
  }
  RDOMBuilder.prototype.setProp = function (attribute, value) {
    var key = fixAttributeName(attribute);
    var tmp0_asDynamic_0 = this._props;
    tmp0_asDynamic_0[key] = value;
  };
  RDOMBuilder.prototype.create_0 = function () {
    var tmp = this._attrs_0._get_tagName__5();
    var tmp0_toTypedArray_0 = this._get_childList__1();
    return createElement.apply(null, [].concat([tmp], [this._props], [].slice.call(copyToArray_0(tmp0_toTypedArray_0).slice())));
  };
  RDOMBuilder.$metadata$ = {
    simpleName: 'RDOMBuilder',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__40($this) {
    this._$this_19 = $this;
  }
  _no_name_provided__40.prototype.onTagAttributeChange_0 = function (tag, attribute, value) {
    this._$this_19.setProp(attribute, value);
  };
  _no_name_provided__40.prototype.onTagEvent_0 = function (tag, event, value) {
    this._$this_19.setProp(event, value);
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: [TagConsumer]
  };
  function render_0(container, callback, handler) {
    return render(buildElements(handler), container, callback);
  }
  function render$default(container, callback, handler, $mask0, $handler) {
    var tmp;
    if (!(($mask0 & 2) === 0)) {
      tmp = _no_name_provided_$factory_29();
    } else {
      tmp = callback;
    }
    var callback_0 = tmp;
    return render_0(container, callback_0, handler);
  }
  function _no_name_provided__41() {
  }
  _no_name_provided__41.prototype.invoke_60 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__41.prototype.invoke_61 = function () {
    this.invoke_60();
    return Unit_getInstance();
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_29() {
    var i = new _no_name_provided__41();
    return function () {
      i.invoke_60();
      return Unit_getInstance();
    };
  }
  var events;
  var attrsMap;
  var key$delegate;
  var defaultValue$delegate;
  var defaultValue$delegate_0;
  var value$delegate;
  function StringAttr() {
    StringAttr_instance = this;
  }
  StringAttr.$metadata$ = {
    simpleName: 'StringAttr',
    kind: 'object',
    interfaces: []
  };
  var StringAttr_instance;
  function StringAttr_getInstance() {
    if (StringAttr_instance == null)
      new StringAttr();
    return StringAttr_instance;
  }
  function fixAttributeName(event) {
    var tmp0_elvis_lhs = attrsMap.get_26(event);
    return tmp0_elvis_lhs == null ? event : tmp0_elvis_lhs;
  }
  function attrsMap$init$() {
    var tmp0_map_0 = events;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_42();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var item_2_3 = tmp0_iterator_1_2.next_14();
      tmp0_mapTo_0_1.add_18(to(item_2_3.toLowerCase(), item_2_3));
      Unit_getInstance();
    }
    var tmp1_apply_0 = toMutableMap(toMap(tmp0_mapTo_0_1));
    tmp1_apply_0.put_7('class', 'className');
    Unit_getInstance();
    tmp1_apply_0.put_7('ondblclick', 'onDoubleClick');
    Unit_getInstance();
    return tmp1_apply_0;
  }
  var globalStylesCounter;
  function Scanner() {
    Scanner_instance = this;
    this._singleVowels = Regex_init_$Create$('[aeiou]');
    this._diphthongs = Regex_init_$Create$('([ao]e)|(ei)|([ae]u)');
    this._elisions = Regex_init_$Create$('' + this._singleVowels._pattern + 'm? h?' + this._singleVowels._pattern);
    this._longByPosition = Regex_init_$Create$('' + this._singleVowels._pattern + ' ?([zx]|([bcdfgjklmnpqrst] ?[bcdfgjkmnpqstxz])|([klmnqrs] ?r)|([bcdfgjptxz] r)|([bcdjklmnqrst] ?l)|([fgp] l))');
  }
  Scanner.prototype.scan = function (input, meter) {
    var line = input.toLowerCase();
    var result = markLongByPosition(markDiphthongsLong(findElisions(findVowels(this, line), this, line), this, line), this, line);
    var tmp0_filterNotTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = result.iterator_42();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var element_2_3 = tmp0_iterator_1_2.next_14();
      if (!element_2_3._isElided) {
        tmp0_filterNotTo_0_1.add_18(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    meter.applyTo_0(tmp0_filterNotTo_0_1);
    Unit_getInstance();
    var tmp0_filterNotTo_0_1_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = result.iterator_42();
    while (tmp0_iterator_1_2_0.hasNext_12()) {
      var element_2_3_0 = tmp0_iterator_1_2_0.next_14();
      if (!element_2_3_0._isElided) {
        tmp0_filterNotTo_0_1_0.add_18(element_2_3_0);
        Unit_getInstance();
      } else {
      }
    }
    inferVowelStresses$default(this, tmp0_filterNotTo_0_1_0, meter, null, 0, null, 56, null);
    return result;
  };
  Scanner.$metadata$ = {
    simpleName: 'Scanner',
    kind: 'object',
    interfaces: []
  };
  var Scanner_instance;
  function Scanner_getInstance() {
    if (Scanner_instance == null)
      new Scanner();
    return Scanner_instance;
  }
  function Vowel(position) {
    this._position = position;
    this._isElided = false;
    this._stress = Stress_UNKNOWN_getInstance();
  }
  Vowel.$metadata$ = {
    simpleName: 'Vowel',
    kind: 'class',
    interfaces: []
  };
  function Stress(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Stress.prototype.matches_0 = function (other) {
    return (this.equals(Stress_UNKNOWN_getInstance()) ? true : other.equals(Stress_UNKNOWN_getInstance())) ? true : this.equals(other);
  };
  Stress.$metadata$ = {
    simpleName: 'Stress',
    kind: 'class',
    interfaces: []
  };
  function Foot(name, ordinal, stresses) {
    Enum.call(this, name, ordinal);
    this._stresses = stresses;
  }
  Foot.prototype.contains_26 = function (element) {
    return this._stresses.contains_29(element);
  };
  Foot.prototype.contains_29 = function (element) {
    if (!(element instanceof Stress))
      return false;
    else {
    }
    return this.contains_26(element instanceof Stress ? element : THROW_CCE());
  };
  Foot.prototype.containsAll_19 = function (elements) {
    return this._stresses.containsAll_22(elements);
  };
  Foot.prototype.containsAll_22 = function (elements) {
    return this.containsAll_19(elements);
  };
  Foot.prototype.get_38 = function (index) {
    return this._stresses.get_38(index);
  };
  Foot.prototype.isEmpty_28 = function () {
    return this._stresses.isEmpty_28();
  };
  Foot.prototype.iterator_42 = function () {
    return this._stresses.iterator_42();
  };
  Foot.prototype.subList_5 = function (fromIndex, toIndex) {
    return this._stresses.subList_5(fromIndex, toIndex);
  };
  Foot.prototype._get_size__29 = function () {
    return this._stresses._get_size__29();
  };
  Foot.prototype.matches_1 = function (vowels) {
    var iterator = vowels.iterator_42();
    var index = 0;
    while (iterator.hasNext_12()) {
      var i = index;
      index = index + 1 | 0;
      var vowel = iterator.next_14();
      if (!vowel._stress.matches_0(this.get_38(i)))
        return false;
    }
    return true;
  };
  Foot.prototype.applyTo_0 = function (vowels) {
    var tmp0_forEach_0 = zip(vowels, this);
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_42();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      var vowel_4 = element_2.component1();
      var stress_5 = element_2.component2();
      vowel_4._stress = stress_5;
    }
    return vowels;
  };
  Foot.$metadata$ = {
    simpleName: 'Foot',
    kind: 'class',
    interfaces: [List]
  };
  function Meter(name, ordinal, feet, allowedFeet) {
    Enum.call(this, name, ordinal);
    this._feet = feet;
    this._allowedFeet = allowedFeet;
  }
  Meter.prototype.contains_28 = function (element) {
    return this._feet.contains_29(element);
  };
  Meter.prototype.contains_29 = function (element) {
    if (!(element == null ? true : element instanceof Foot))
      return false;
    else {
    }
    return this.contains_28((element == null ? true : element instanceof Foot) ? element : THROW_CCE());
  };
  Meter.prototype.containsAll_21 = function (elements) {
    return this._feet.containsAll_22(elements);
  };
  Meter.prototype.containsAll_22 = function (elements) {
    return this.containsAll_21(elements);
  };
  Meter.prototype.get_38 = function (index) {
    return this._feet.get_38(index);
  };
  Meter.prototype.isEmpty_28 = function () {
    return this._feet.isEmpty_28();
  };
  Meter.prototype.iterator_42 = function () {
    return this._feet.iterator_42();
  };
  Meter.prototype.subList_5 = function (fromIndex, toIndex) {
    return this._feet.subList_5(fromIndex, toIndex);
  };
  Meter.prototype._get_size__29 = function () {
    return this._feet._get_size__29();
  };
  Meter.prototype.applyTo_0 = function (vowels) {
    var i = 0;
    var tmp0_iterator = reversed(this._feet).iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var foot = tmp0_iterator.next_14();
      if (!(foot == null)) {
        if (((_get_lastIndex__0(vowels) - i | 0) - foot._get_size__29() | 0) < 0)
          return vowels;
        foot.applyTo_0(vowels.subList_5((vowels._get_size__29() - i | 0) - foot._get_size__29() | 0, vowels._get_size__29() - i | 0));
        Unit_getInstance();
        i = i + foot._get_size__29() | 0;
      }}
    return vowels;
  };
  Meter.$metadata$ = {
    simpleName: 'Meter',
    kind: 'class',
    interfaces: [List]
  };
  function Stress_STRESSED_getInstance() {
    Stress_initEntries();
    return Stress_STRESSED_instance;
  }
  function Stress_UNSTRESSED_getInstance() {
    Stress_initEntries();
    return Stress_UNSTRESSED_instance;
  }
  function Stress_UNKNOWN_getInstance() {
    Stress_initEntries();
    return Stress_UNKNOWN_instance;
  }
  function Foot_DACTYL_getInstance() {
    Foot_initEntries();
    return Foot_DACTYL_instance;
  }
  function Foot_SPONDEE_getInstance() {
    Foot_initEntries();
    return Foot_SPONDEE_instance;
  }
  function Foot_FLOATING_getInstance() {
    Foot_initEntries();
    return Foot_FLOATING_instance;
  }
  function Meter_DACTYLIC_HEXAMETER_getInstance() {
    Meter_initEntries();
    return Meter_DACTYLIC_HEXAMETER_instance;
  }
  function Meter_DACTYLIC_PENTAMETER_getInstance() {
    Meter_initEntries();
    return Meter_DACTYLIC_PENTAMETER_instance;
  }
  function Meter_UNKNOWN_getInstance() {
    Meter_initEntries();
    return Meter_UNKNOWN_instance;
  }
  function _no_name_provided_$factory_30($foundDiphthongs) {
    var i = new _no_name_provided__42($foundDiphthongs);
    return function (p1) {
      return i.invoke_66(p1);
    };
  }
  function _no_name_provided_$factory_31() {
    var i = new _no_name_provided__43();
    return function (p1) {
      return i.invoke_66(p1);
    };
  }
  function _no_name_provided_$factory_32() {
    var i = new _no_name_provided__44();
    return function (p1) {
      return i.invoke_66(p1);
    };
  }
  function _no_name_provided_$factory_33() {
    var i = new _no_name_provided__45();
    return function (p1, p2) {
      return i.invoke_68(p1, p2);
    };
  }
  function _no_name_provided_$factory_34($meter) {
    var i = new _no_name_provided__46($meter);
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_35($vowels) {
    var i = new _no_name_provided__47($vowels);
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_36($vowels) {
    var i = new _no_name_provided__48($vowels);
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function findVowels($this, input) {
    var foundDiphthongs = $this._diphthongs.findAll$default(input, 0, 2, null);
    var foundSingleVowels = $this._singleVowels.findAll$default(input, 0, 2, null);
    var tmp = filterNot(foundSingleVowels, _no_name_provided_$factory_30(foundDiphthongs));
    var result = toMutableList_2(map(tmp, _no_name_provided_$factory_31()));
    addAll(result, map(foundDiphthongs, _no_name_provided_$factory_32()));
    Unit_getInstance();
    var tmp0 = _no_name_provided_$factory_33();
    return sortedWith(result, new sam$kotlin_Comparator$0(tmp0));
  }
  function findElisions(_this_, $this, input) {
    var tmp0_forEach_0 = $this._elisions.findAll$default(input, 0, 2, null);
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_42();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_iterator_1_1_5 = _this_.iterator_42();
        while (tmp0_iterator_1_1_5.hasNext_12()) {
          var element_2_2_6 = tmp0_iterator_1_1_5.next_14();
          if (element_2._get_range__0().contains_7(element_2_2_6._position._get_last__0())) {
            tmp$ret$0 = element_2_2_6;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp0_safe_receiver_4 = tmp$ret$0;
      if (tmp0_safe_receiver_4 == null) {
        Unit_getInstance();
      } else
        tmp0_safe_receiver_4._isElided = true;
    }
    return _this_;
  }
  function markDiphthongsLong(_this_, $this, input) {
    var tmp0_iterator_1 = _this_.iterator_42();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      if (!(element_2._position._get_first__0() === element_2._position._get_last__0()))
        element_2._stress = Stress_STRESSED_getInstance();
    }
    return _this_;
  }
  function markLongByPosition(_this_, $this, input) {
    var tmp0_forEach_0 = $this._longByPosition.findAll$default(input, 0, 2, null);
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_42();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_iterator_1_1_5 = _this_.iterator_42();
        while (tmp0_iterator_1_1_5.hasNext_12()) {
          var element_2_2_6 = tmp0_iterator_1_1_5.next_14();
          if (element_2._get_range__0().contains_7(element_2_2_6._position._get_last__0())) {
            tmp$ret$0 = element_2_2_6;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp0_safe_receiver_4 = tmp$ret$0;
      if (tmp0_safe_receiver_4 == null) {
        Unit_getInstance();
      } else
        tmp0_safe_receiver_4._stress = Stress_STRESSED_getInstance();
    }
    return _this_;
  }
  function inferVowelStresses($this, vowels, meter, fullVowels, vowelsStartsFrom, feet) {
    var $this_0 = $this;
    var vowels_0 = vowels;
    var meter_0 = meter;
    var fullVowels_0 = fullVowels;
    var vowelsStartsFrom_0 = vowelsStartsFrom;
    var feet_0 = feet;
    while (true) {
      var $this_1 = $this_0;
      var vowels_1 = vowels_0;
      var meter_1 = meter_0;
      var fullVowels_1 = fullVowels_0;
      var vowelsStartsFrom_1 = vowelsStartsFrom_0;
      var feet_1 = feet_0;
      var tmp = filter(feet_1, _no_name_provided_$factory_34(meter_1));
      var tmp_0 = filter(tmp, _no_name_provided_$factory_35(vowels_1));
      var foot = firstOrNull(filter(tmp_0, _no_name_provided_$factory_36(vowels_1)));
      if (!(foot == null)) {
        foot.applyTo_0(vowels_1);
        Unit_getInstance();
        if (!equals(fullVowels_1, vowels_1) ? fullVowels_1._get_size__29() > (vowels_1._get_size__29() + vowelsStartsFrom_1 | 0) : false) {
          $this_0 = $this_1;
          vowels_0 = fullVowels_1.subList_5(vowels_1._get_size__29() + vowelsStartsFrom_1 | 0, fullVowels_1._get_size__29());
          meter_0 = meter_1;
          fullVowels_0 = fullVowels_1;
          vowelsStartsFrom_0 = vowels_1._get_size__29() + vowelsStartsFrom_1 | 0;
          feet_0 = feet_1;
          continue;
        }} else if (vowels_1._get_size__29() > 1) {
        $this_0 = $this_1;
        vowels_0 = vowels_1.subList_5(0, _get_lastIndex__0(vowels_1));
        meter_0 = meter_1;
        fullVowels_0 = fullVowels_1;
        vowelsStartsFrom_0 = vowelsStartsFrom_1;
        feet_0 = feet_1;
        continue;
      }break;
    }
  }
  function inferVowelStresses$default($this, vowels, meter, fullVowels, vowelsStartsFrom, feet, $mask0, $handler) {
    var fullVowels_0 = !(($mask0 & 8) === 0) ? vowels : fullVowels;
    var vowelsStartsFrom_0 = !(($mask0 & 16) === 0) ? 0 : vowelsStartsFrom;
    var feet_0 = !(($mask0 & 32) === 0) ? asSequence(values_0()) : feet;
    return inferVowelStresses($this, vowels, meter, fullVowels_0, vowelsStartsFrom_0, feet_0);
  }
  function overlaps(_this_, $this, other) {
    return _this_._get_first__0() <= other._get_last__0() ? _this_._get_last__0() >= other._get_first__0() : false;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_0 = function (a, b) {
    return this._function(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_0(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__42($foundDiphthongs) {
    this._$foundDiphthongs = $foundDiphthongs;
  }
  _no_name_provided__42.prototype.invoke_66 = function (vowel) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = this._$foundDiphthongs.iterator_42();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (overlaps(vowel._get_range__0(), Scanner_getInstance(), element_2._get_range__0())) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  _no_name_provided__42.prototype.invoke_105 = function (p1) {
    return this.invoke_66((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__43() {
  }
  _no_name_provided__43.prototype.invoke_66 = function (it) {
    return new Vowel(it._get_range__0());
  };
  _no_name_provided__43.prototype.invoke_105 = function (p1) {
    return this.invoke_66((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_66 = function (it) {
    return new Vowel(it._get_range__0());
  };
  _no_name_provided__44.prototype.invoke_105 = function (p1) {
    return this.invoke_66((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45() {
  }
  _no_name_provided__45.prototype.invoke_68 = function (a, b) {
    var tmp = a._position._get_first__0();
    return compareValues(tmp, b._position._get_first__0());
  };
  _no_name_provided__45.prototype.invoke_69 = function (p1, p2) {
    var tmp = p1 instanceof Vowel ? p1 : THROW_CCE();
    return this.invoke_68(tmp, p2 instanceof Vowel ? p2 : THROW_CCE());
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46($meter) {
    this._$meter = $meter;
  }
  _no_name_provided__46.prototype.invoke_74 = function (it) {
    return this._$meter._allowedFeet.contains_29(it);
  };
  _no_name_provided__46.prototype.invoke_105 = function (p1) {
    return this.invoke_74(p1 instanceof Foot ? p1 : THROW_CCE());
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__47($vowels) {
    this._$vowels = $vowels;
  }
  _no_name_provided__47.prototype.invoke_74 = function (it) {
    return it._get_size__29() === this._$vowels._get_size__29();
  };
  _no_name_provided__47.prototype.invoke_105 = function (p1) {
    return this.invoke_74(p1 instanceof Foot ? p1 : THROW_CCE());
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__48($vowels) {
    this._$vowels_0 = $vowels;
  }
  _no_name_provided__48.prototype.invoke_74 = function (it) {
    return it.matches_1(this._$vowels_0);
  };
  _no_name_provided__48.prototype.invoke_105 = function (p1) {
    return this.invoke_74(p1 instanceof Foot ? p1 : THROW_CCE());
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var Stress_STRESSED_instance;
  var Stress_UNSTRESSED_instance;
  var Stress_UNKNOWN_instance;
  var Stress_entriesInitialized;
  function Stress_initEntries() {
    if (Stress_entriesInitialized)
      return Unit_getInstance();
    Stress_entriesInitialized = true;
    Stress_STRESSED_instance = new Stress('STRESSED', 0);
    Stress_UNSTRESSED_instance = new Stress('UNSTRESSED', 1);
    Stress_UNKNOWN_instance = new Stress('UNKNOWN', 2);
  }
  var Foot_DACTYL_instance;
  var Foot_SPONDEE_instance;
  var Foot_FLOATING_instance;
  function values_0() {
    return [Foot_DACTYL_getInstance(), Foot_SPONDEE_getInstance(), Foot_FLOATING_getInstance()];
  }
  var Foot_entriesInitialized;
  function Foot_initEntries() {
    if (Foot_entriesInitialized)
      return Unit_getInstance();
    Foot_entriesInitialized = true;
    Foot_DACTYL_instance = new Foot('DACTYL', 0, listOf([Stress_STRESSED_getInstance(), Stress_UNSTRESSED_getInstance(), Stress_UNSTRESSED_getInstance()]));
    Foot_SPONDEE_instance = new Foot('SPONDEE', 1, listOf([Stress_STRESSED_getInstance(), Stress_STRESSED_getInstance()]));
    Foot_FLOATING_instance = new Foot('FLOATING', 2, listOf_0(Stress_STRESSED_getInstance()));
  }
  var Meter_DACTYLIC_HEXAMETER_instance;
  var Meter_DACTYLIC_PENTAMETER_instance;
  var Meter_UNKNOWN_instance;
  function values_1() {
    return [Meter_DACTYLIC_HEXAMETER_getInstance(), Meter_DACTYLIC_PENTAMETER_getInstance(), Meter_UNKNOWN_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'DACTYLIC_HEXAMETER':
        return Meter_DACTYLIC_HEXAMETER_getInstance();
      case 'DACTYLIC_PENTAMETER':
        return Meter_DACTYLIC_PENTAMETER_getInstance();
      case 'UNKNOWN':
        return Meter_UNKNOWN_getInstance();
      default:return THROW_ISE();
    }
  }
  var Meter_entriesInitialized;
  function Meter_initEntries() {
    if (Meter_entriesInitialized)
      return Unit_getInstance();
    Meter_entriesInitialized = true;
    Meter_DACTYLIC_HEXAMETER_instance = new Meter('DACTYLIC_HEXAMETER', 0, listOf([null, null, null, null, Foot_DACTYL_getInstance(), Foot_SPONDEE_getInstance()]), setOf([Foot_DACTYL_getInstance(), Foot_SPONDEE_getInstance()]));
    Meter_DACTYLIC_PENTAMETER_instance = new Meter('DACTYLIC_PENTAMETER', 1, listOf([null, null, Foot_FLOATING_getInstance(), Foot_DACTYL_getInstance(), Foot_DACTYL_getInstance(), Foot_FLOATING_getInstance()]), setOf([Foot_DACTYL_getInstance(), Foot_SPONDEE_getInstance()]));
    Meter_UNKNOWN_instance = new Meter('UNKNOWN', 2, emptyList(), toList(values_0()));
  }
  function main() {
    var tmp = window;
    tmp.onload = _no_name_provided_$factory_37();
  }
  function _no_name_provided__49() {
  }
  _no_name_provided__49.prototype.invoke_102 = function (it) {
    var tmp = document.getElementById('root');
    render$default(tmp, null, _no_name_provided_$factory_38(), 2, null);
  };
  _no_name_provided__49.prototype.invoke_105 = function (p1) {
    this.invoke_102(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_37() {
    var i = new _no_name_provided__49();
    return function (p1) {
      i.invoke_102(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_38() {
    var i = new _no_name_provided__52();
    return function (p1) {
      i.invoke_82(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_39() {
    var i = new _no_name_provided__51();
    return function (p1) {
      i.invoke_80(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_40() {
    var i = new _no_name_provided__50();
    return function (p1) {
      i.invoke_78(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__50() {
  }
  _no_name_provided__50.prototype.invoke_78 = function (_this__0) {
    _this__0.input = '';
  };
  _no_name_provided__50.prototype.invoke_105 = function (p1) {
    this.invoke_78((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51() {
  }
  _no_name_provided__51.prototype.invoke_80 = function (_this__0) {
    _this__0.attrs_0(_no_name_provided_$factory_40());
  };
  _no_name_provided__51.prototype.invoke_105 = function (p1) {
    this.invoke_80(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__52() {
  }
  _no_name_provided__52.prototype.invoke_82 = function (_this__0) {
    var tmp = getKClass_0(ScansioniserUI);
    _this__0.child_10(tmp, _no_name_provided_$factory_39());
    Unit_getInstance();
  };
  _no_name_provided__52.prototype.invoke_105 = function (p1) {
    this.invoke_82(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIState(input, meter, output) {
    this._input = input;
    this._meter = meter;
    this._output = output;
  }
  UIState.prototype.toString = function () {
    return '' + 'UIState(input=' + this._input + ', meter=' + this._meter + ', output=' + this._output + ')';
  };
  UIState.prototype.hashCode = function () {
    return imul(imul(getStringHashCode(this._input), 31) + this._meter.hashCode() | 0, 31) + (this._output == null ? 0 : getStringHashCode(this._output)) | 0;
  };
  UIState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UIState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UIState ? other : THROW_CCE();
    if (!(this._input === tmp0_other_with_cast._input))
      return false;
    if (!this._meter.equals(tmp0_other_with_cast._meter))
      return false;
    if (!(this._output == tmp0_other_with_cast._output))
      return false;
    return true;
  };
  UIState.$metadata$ = {
    simpleName: 'UIState',
    kind: 'class',
    interfaces: []
  };
  function ScansioniserUI(props) {
    RComponent_init_$Init$(props, this);
    var tmp = props.input;
    var tmp_0 = Meter_UNKNOWN_getInstance();
    this.state = UIState_init_$Create$(tmp, tmp_0, null, 4, null);
  }
  ScansioniserUI.prototype.render_2 = function (_this__0) {
    var tmp0_fieldSet_0 = null;
    var tmp1_tag_0_1 = _no_name_provided_$factory_41(tmp0_fieldSet_0);
    var tmp0_apply_0_3 = new RDOMBuilder(tmp1_tag_0_1);
    var tmp0_legend_0_5 = null;
    var tmp1_tag_0_1_6 = _no_name_provided_$factory_42(tmp0_legend_0_5);
    var tmp0_apply_0_3_8 = new RDOMBuilder(tmp1_tag_0_1_6);
    tmp0_apply_0_3_8.unaryPlus_0('Meter:');
    tmp0_apply_0_3.child_7(tmp0_apply_0_3_8.create_0());
    Unit_getInstance();
    var tmp1_map_0_9 = values_1();
    var tmp0_mapTo_0_1_10 = ArrayList_init_$Create$_0(tmp1_map_0_9.length);
    var indexedObject = tmp1_map_0_9;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item_2_3_12 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_div_0_5_13 = null;
      var tmp1_tag_0_1_6_14 = _no_name_provided_$factory_43(tmp0_div_0_5_13);
      var tmp0_apply_0_3_8_16 = new RDOMBuilder(tmp1_tag_0_1_6_14);
      var tmp0_input_0_5_9_17 = null;
      var tmp1_input_0_6_10_18 = null;
      var tmp2_input_0_7_11_19 = null;
      var tmp3_input_0_8_12_20 = null;
      var tmp4_input_0_9_13_21 = null;
      var tmp1_tag_0_1_10_14_22 = _no_name_provided_$factory_44(tmp0_input_0_5_9_17, tmp1_input_0_6_10_18, tmp2_input_0_7_11_19, tmp3_input_0_8_12_20, tmp4_input_0_9_13_21);
      var tmp0_apply_0_6_15_19_27 = new RDOMBuilder(tmp1_tag_0_1_10_14_22);
      var tmp0__anonymous__1_8_16_20_28 = tmp0_apply_0_6_15_19_27._attrs_0;
      tmp0__anonymous__1_8_16_20_28._set_type_(InputType_radio_getInstance());
      tmp0__anonymous__1_8_16_20_28._set_value_(item_2_3_12._get_name__0());
      _set_id_(tmp0__anonymous__1_8_16_20_28, item_2_3_12._get_name__0());
      tmp0__anonymous__1_8_16_20_28._set_name_('meter');
      _set_onChangeFunction_(tmp0__anonymous__1_8_16_20_28, _no_name_provided_$factory_45(this));
      tmp0_apply_0_3_8_16.child_7(tmp0_apply_0_6_15_19_27.create_0());
      Unit_getInstance();
      var tmp5_label_0_20_24_32 = null;
      var tmp1_tag_0_1_21_25_33 = _no_name_provided_$factory_46(tmp5_label_0_20_24_32);
      var tmp0_apply_0_3_23_27_35 = new RDOMBuilder(tmp1_tag_0_1_21_25_33);
      var tmp0_toLowerCase_0_5_24_28_36 = item_2_3_12._get_name__0();
      var tmp = tmp0_toLowerCase_0_5_24_28_36.toLowerCase();
      tmp0_apply_0_3_23_27_35.unaryPlus_0(capitalize(replace$default(tmp, new Char(95), new Char(32), false, 4, null)));
      tmp0_apply_0_3_8_16.child_7(tmp0_apply_0_3_23_27_35.create_0());
      Unit_getInstance();
      tmp0_mapTo_0_1_10.add_18(tmp0_apply_0_3.child_7(tmp0_apply_0_3_8_16.create_0()));
      Unit_getInstance();
    }
    Unit_getInstance();
    _this__0.child_7(tmp0_apply_0_3.create_0());
    Unit_getInstance();
    var tmp1_input_0 = null;
    var tmp2_input_0 = null;
    var tmp3_input_0 = null;
    var tmp4_input_0 = null;
    var tmp5_input_0 = null;
    var tmp1_tag_0_1_0 = _no_name_provided_$factory_47(tmp1_input_0, tmp2_input_0, tmp3_input_0, tmp4_input_0, tmp5_input_0);
    var tmp0_apply_0_6 = new RDOMBuilder(tmp1_tag_0_1_0);
    var tmp0__anonymous__1_8 = tmp0_apply_0_6._attrs_0;
    var tmp0_receiver_2_9 = tmp0__anonymous__1_8;
    _set_classes_(tmp0_receiver_2_9, plus(_get_classes_(tmp0_receiver_2_9), 'textContainer'));
    var tmp1__anonymous__1_10 = tmp0_apply_0_6._attrs_0;
    tmp1__anonymous__1_10._set_type_(InputType_text_getInstance());
    tmp1__anonymous__1_10._set_value_(this.state._input);
    _set_onChangeFunction_(tmp1__anonymous__1_10, _no_name_provided_$factory_48(this));
    _this__0.child_7(tmp0_apply_0_6.create_0());
    Unit_getInstance();
    var tmp6_div_0 = null;
    var tmp1_tag_0_1_1 = _no_name_provided_$factory_49(tmp6_div_0);
    var tmp0_apply_0_3_0 = new RDOMBuilder(tmp1_tag_0_1_1);
    var tmp0__anonymous__1_5 = tmp0_apply_0_3_0._attrs_0;
    var tmp0_receiver_2_6 = tmp0__anonymous__1_5;
    _set_classes_(tmp0_receiver_2_6, plus(_get_classes_(tmp0_receiver_2_6), 'textContainer'));
    var tmp0_elvis_lhs_7 = this.state._output;
    tmp0_apply_0_3_0.unaryPlus_0(tmp0_elvis_lhs_7 == null ? '' : tmp0_elvis_lhs_7);
    _this__0.child_7(tmp0_apply_0_3_0.create_0());
    Unit_getInstance();
  };
  ScansioniserUI.$metadata$ = {
    simpleName: 'ScansioniserUI',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_41($tmp0_fieldSet_0) {
    var i = new _no_name_provided__55($tmp0_fieldSet_0);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_42($tmp0_legend_0_5) {
    var i = new _no_name_provided__56($tmp0_legend_0_5);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_43($tmp0_div_0_5_13) {
    var i = new _no_name_provided__57($tmp0_div_0_5_13);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_44($tmp0_input_0_5_9_17, $tmp1_input_0_6_10_18, $tmp2_input_0_7_11_19, $tmp3_input_0_8_12_20, $tmp4_input_0_9_13_21) {
    var i = new _no_name_provided__58($tmp0_input_0_5_9_17, $tmp1_input_0_6_10_18, $tmp2_input_0_7_11_19, $tmp3_input_0_8_12_20, $tmp4_input_0_9_13_21);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_45($this) {
    var i = new _no_name_provided__59($this);
    return function (p1) {
      i.invoke_102(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_46($tmp5_label_0_20_24_32) {
    var i = new _no_name_provided__60($tmp5_label_0_20_24_32);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_47($tmp1_input_0, $tmp2_input_0, $tmp3_input_0, $tmp4_input_0, $tmp5_input_0) {
    var i = new _no_name_provided__61($tmp1_input_0, $tmp2_input_0, $tmp3_input_0, $tmp4_input_0, $tmp5_input_0);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_48($this) {
    var i = new _no_name_provided__62($this);
    return function (p1) {
      i.invoke_102(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49($tmp6_div_0) {
    var i = new _no_name_provided__63($tmp6_div_0);
    return function (p1) {
      return i.invoke_104(p1);
    };
  }
  function _no_name_provided_$factory_50($this, $meter_3_10_18_22_30) {
    var i = new _no_name_provided__53($this, $meter_3_10_18_22_30);
    return function (p1) {
      return i.invoke_86(p1);
    };
  }
  function _no_name_provided_$factory_51($this, $input_3_12) {
    var i = new _no_name_provided__54($this, $input_3_12);
    return function (p1) {
      return i.invoke_86(p1);
    };
  }
  function UIState_init_$Init$(input, meter, output, $mask0, $marker, $this) {
    var output_0 = !(($mask0 & 4) === 0) ? null : output;
    UIState.call($this, input, meter, output_0);
    return $this;
  }
  function UIState_init_$Create$(input, meter, output, $mask0, $marker) {
    return UIState_init_$Init$(input, meter, output, $mask0, $marker, Object.create(UIState.prototype));
  }
  function _no_name_provided__53($this, $meter_3_10_18_22_30) {
    this._$this_20 = $this;
    this._$meter_3_10_18_22_30 = $meter_3_10_18_22_30;
  }
  _no_name_provided__53.prototype.invoke_86 = function (s) {
    return updateOutput(this._$this_20, s._input, valueOf(this._$meter_3_10_18_22_30));
  };
  _no_name_provided__53.prototype.invoke_105 = function (p1) {
    return this.invoke_86(p1 instanceof UIState ? p1 : THROW_CCE());
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__54($this, $input_3_12) {
    this._$this_21 = $this;
    this._$input_3_12 = $input_3_12;
  }
  _no_name_provided__54.prototype.invoke_86 = function (s) {
    return updateOutput(this._$this_21, this._$input_3_12, s._meter);
  };
  _no_name_provided__54.prototype.invoke_105 = function (p1) {
    return this.invoke_86(p1 instanceof UIState ? p1 : THROW_CCE());
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function updateOutput($this, input, meter) {
    var output = toMutableList_3(input);
    var offset = 0;
    var tmp0_iterator = Scanner_getInstance().scan(input, meter).iterator_42();
    while (tmp0_iterator.hasNext_12()) {
      var vowel = tmp0_iterator.next_14();
      if (vowel._isElided) {
        output.add_17((vowel._position._get_last__0() + 1 | 0) + offset | 0, new Char(41));
        output.add_17(vowel._position._get_first__0() + offset | 0, new Char(40));
        offset = offset + 2 | 0;
      } else {
        var tmp1_subject = vowel._stress;
        if (tmp1_subject.equals(Stress_STRESSED_getInstance())) {
          var progression = vowel._position;
          var inductionVariable = progression._get_first__0();
          var last = progression._get_last__0();
          var step = progression._get_step__0();
          if ((step > 0 ? inductionVariable <= last : false) ? true : step < 0 ? last <= inductionVariable : false)
            do {
              var position = inductionVariable;
              inductionVariable = inductionVariable + step | 0;
              var tmp3 = offset;
              offset = tmp3 + 1 | 0;
              Unit_getInstance();
              output.add_17(position + offset | 0, new Char(772));
            }
             while (!(position === last));
        } else if (tmp1_subject.equals(Stress_UNSTRESSED_getInstance())) {
          var progression_0 = vowel._position;
          var inductionVariable_0 = progression_0._get_first__0();
          var last_0 = progression_0._get_last__0();
          var step_0 = progression_0._get_step__0();
          if ((step_0 > 0 ? inductionVariable_0 <= last_0 : false) ? true : step_0 < 0 ? last_0 <= inductionVariable_0 : false)
            do {
              var position_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + step_0 | 0;
              var tmp5 = offset;
              offset = tmp5 + 1 | 0;
              Unit_getInstance();
              output.add_17(position_0 + offset | 0, new Char(774));
            }
             while (!(position_0 === last_0));
        } else if (tmp1_subject.equals(Stress_UNKNOWN_getInstance())) {
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var tmp = copyToArray_0(output);
    return new UIState(input, meter, joinToString$default(tmp, '', null, null, 0, null, null, 62, null));
  }
  function _no_name_provided__55($tmp0_fieldSet_0) {
    this._$tmp0_fieldSet_0 = $tmp0_fieldSet_0;
  }
  _no_name_provided__55.prototype.invoke_104 = function (it) {
    return new FIELDSET(attributesMapOf('class', this._$tmp0_fieldSet_0), it);
  };
  _no_name_provided__55.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__56($tmp0_legend_0_5) {
    this._$tmp0_legend_0_5 = $tmp0_legend_0_5;
  }
  _no_name_provided__56.prototype.invoke_104 = function (it) {
    return new LEGEND(attributesMapOf('class', this._$tmp0_legend_0_5), it);
  };
  _no_name_provided__56.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__57($tmp0_div_0_5_13) {
    this._$tmp0_div_0_5_13 = $tmp0_div_0_5_13;
  }
  _no_name_provided__57.prototype.invoke_104 = function (it) {
    return new DIV(attributesMapOf('class', this._$tmp0_div_0_5_13), it);
  };
  _no_name_provided__57.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__58($tmp0_input_0_5_9_17, $tmp1_input_0_6_10_18, $tmp2_input_0_7_11_19, $tmp3_input_0_8_12_20, $tmp4_input_0_9_13_21) {
    this._$tmp0_input_0_5_9_17 = $tmp0_input_0_5_9_17;
    this._$tmp1_input_0_6_10_18 = $tmp1_input_0_6_10_18;
    this._$tmp2_input_0_7_11_19 = $tmp2_input_0_7_11_19;
    this._$tmp3_input_0_8_12_20 = $tmp3_input_0_8_12_20;
    this._$tmp4_input_0_9_13_21 = $tmp4_input_0_9_13_21;
  }
  _no_name_provided__58.prototype.invoke_104 = function (it) {
    var tmp0_safe_receiver_3_12_16_24 = this._$tmp0_input_0_5_9_17;
    var tmp = tmp0_safe_receiver_3_12_16_24 == null ? null : enumEncode(tmp0_safe_receiver_3_12_16_24);
    var tmp1_safe_receiver_4_13_17_25 = this._$tmp1_input_0_6_10_18;
    var tmp_0 = tmp1_safe_receiver_4_13_17_25 == null ? null : enumEncode(tmp1_safe_receiver_4_13_17_25);
    var tmp2_safe_receiver_5_14_18_26 = this._$tmp2_input_0_7_11_19;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_14_18_26 == null ? null : enumEncode(tmp2_safe_receiver_5_14_18_26), 'name', this._$tmp3_input_0_8_12_20, 'class', this._$tmp4_input_0_9_13_21]), it);
  };
  _no_name_provided__58.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__59($this) {
    this._$this_22 = $this;
  }
  _no_name_provided__59.prototype.invoke_102 = function (event) {
    var tmp = event.target;
    var meter_3_10_18_22_30 = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
    this._$this_22.setState(_no_name_provided_$factory_50(this._$this_22, meter_3_10_18_22_30), void 1);
  };
  _no_name_provided__59.prototype.invoke_105 = function (p1) {
    this.invoke_102(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__60($tmp5_label_0_20_24_32) {
    this._$tmp5_label_0_20_24_32 = $tmp5_label_0_20_24_32;
  }
  _no_name_provided__60.prototype.invoke_104 = function (it) {
    return new LABEL(attributesMapOf('class', this._$tmp5_label_0_20_24_32), it);
  };
  _no_name_provided__60.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__61($tmp1_input_0, $tmp2_input_0, $tmp3_input_0, $tmp4_input_0, $tmp5_input_0) {
    this._$tmp1_input_0 = $tmp1_input_0;
    this._$tmp2_input_0 = $tmp2_input_0;
    this._$tmp3_input_0 = $tmp3_input_0;
    this._$tmp4_input_0 = $tmp4_input_0;
    this._$tmp5_input_0 = $tmp5_input_0;
  }
  _no_name_provided__61.prototype.invoke_104 = function (it) {
    var tmp0_safe_receiver_3 = this._$tmp1_input_0;
    var tmp = tmp0_safe_receiver_3 == null ? null : enumEncode(tmp0_safe_receiver_3);
    var tmp1_safe_receiver_4 = this._$tmp2_input_0;
    var tmp_0 = tmp1_safe_receiver_4 == null ? null : enumEncode(tmp1_safe_receiver_4);
    var tmp2_safe_receiver_5 = this._$tmp3_input_0;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5 == null ? null : enumEncode(tmp2_safe_receiver_5), 'name', this._$tmp4_input_0, 'class', this._$tmp5_input_0]), it);
  };
  _no_name_provided__61.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__62($this) {
    this._$this_23 = $this;
  }
  _no_name_provided__62.prototype.invoke_102 = function (event) {
    var tmp = event.target;
    var input_3_12 = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
    this._$this_23.setState(_no_name_provided_$factory_51(this._$this_23, input_3_12), void 1);
  };
  _no_name_provided__62.prototype.invoke_105 = function (p1) {
    this.invoke_102(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__63($tmp6_div_0) {
    this._$tmp6_div_0 = $tmp6_div_0;
  }
  _no_name_provided__63.prototype.invoke_104 = function (it) {
    return new DIV(attributesMapOf('class', this._$tmp6_div_0), it);
  };
  _no_name_provided__63.prototype.invoke_105 = function (p1) {
    return this.invoke_104((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  AbstractCollection.prototype._get_size__29 = AbstractCollection.prototype._get_size__29;
  AbstractCollection.prototype.iterator_42 = AbstractCollection.prototype.iterator_42;
  AbstractMap.prototype._get_entries__7 = Map_0.prototype._get_entries__7;
  IntIterator.prototype.nextInt_0 = IntIterator.prototype.nextInt_0;
  IntIterator.prototype.hasNext_12 = Iterator.prototype.hasNext_12;
  IntProgressionIterator.prototype.next_14 = IntIterator.prototype.next_14;
  IntRange.prototype._get_first__0 = IntProgression.prototype._get_first__0;
  IntRange.prototype._get_last__0 = IntProgression.prototype._get_last__0;
  IntRange.prototype._get_step__0 = IntProgression.prototype._get_step__0;
  IntRange.prototype.iterator_42 = IntProgression.prototype.iterator_42;
  AbstractMutableCollection.prototype.add_18 = AbstractMutableCollection.prototype.add_18;
  AbstractMutableCollection.prototype._get_size__29 = AbstractCollection.prototype._get_size__29;
  AbstractMutableCollection.prototype.iterator_42 = AbstractCollection.prototype.iterator_42;
  AbstractMutableCollection.prototype.contains_29 = AbstractCollection.prototype.contains_29;
  AbstractMutableCollection.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  AbstractMutableCollection.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  AbstractMutableCollection.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableCollection.prototype.toArray = AbstractCollection.prototype.toArray;
  AbstractMutableList.prototype.add_17 = AbstractMutableList.prototype.add_17;
  AbstractMutableList.prototype.set_3 = AbstractMutableList.prototype.set_3;
  AbstractMutableList.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  AbstractMutableList.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  AbstractMutableList.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  AbstractMutableList.prototype._get_size__29 = AbstractCollection.prototype._get_size__29;
  AbstractMutableList.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  AbstractMutableList.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  AbstractMutableList.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableList.prototype.toArray = AbstractCollection.prototype.toArray;
  AbstractMutableList.prototype.get_38 = List.prototype.get_38;
  SubList.prototype.toArray = AbstractCollection.prototype.toArray;
  SubList.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  SubList.prototype.add_18 = AbstractMutableList.prototype.add_18;
  SubList.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  SubList.prototype.contains_29 = AbstractMutableList.prototype.contains_29;
  SubList.prototype.indexOf_1 = AbstractMutableList.prototype.indexOf_1;
  SubList.prototype.iterator_42 = AbstractMutableList.prototype.iterator_42;
  SubList.prototype.subList_5 = AbstractMutableList.prototype.subList_5;
  SubList.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  SubList.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  SubList.prototype.equals = AbstractMutableList.prototype.equals;
  SubList.prototype.hashCode = AbstractMutableList.prototype.hashCode;
  SubList.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableMap.prototype.put_7 = AbstractMutableMap.prototype.put_7;
  AbstractMutableMap.prototype.containsKey_9 = AbstractMap.prototype.containsKey_9;
  AbstractMutableMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  AbstractMutableMap.prototype.equals = AbstractMap.prototype.equals;
  AbstractMutableMap.prototype.get_26 = AbstractMap.prototype.get_26;
  AbstractMutableMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  AbstractMutableMap.prototype.isEmpty_28 = AbstractMap.prototype.isEmpty_28;
  AbstractMutableMap.prototype._get_size__29 = AbstractMap.prototype._get_size__29;
  AbstractMutableMap.prototype.toString = AbstractMap.prototype.toString;
  AbstractMutableMap.prototype._get_entries__7 = MutableMap.prototype._get_entries__7;
  AbstractMutableSet.prototype.add_18 = AbstractMutableCollection.prototype.add_18;
  AbstractMutableSet.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  AbstractMutableSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  AbstractMutableSet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  AbstractMutableSet.prototype._get_size__29 = AbstractCollection.prototype._get_size__29;
  AbstractMutableSet.prototype.iterator_42 = AbstractCollection.prototype.iterator_42;
  AbstractMutableSet.prototype.contains_29 = AbstractCollection.prototype.contains_29;
  AbstractMutableSet.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  AbstractMutableSet.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  AbstractMutableSet.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableSet.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__7.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__7.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  _no_name_provided__7.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  _no_name_provided__7.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  _no_name_provided__7.prototype.equals = AbstractMutableSet.prototype.equals;
  _no_name_provided__7.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  _no_name_provided__7.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  _no_name_provided__7.prototype.toString = AbstractCollection.prototype.toString;
  ArrayList.prototype._set_modCount__0 = AbstractMutableList.prototype._set_modCount__0;
  ArrayList.prototype._get_modCount__0 = AbstractMutableList.prototype._get_modCount__0;
  ArrayList.prototype.iterator_42 = AbstractMutableList.prototype.iterator_42;
  ArrayList.prototype.contains_29 = AbstractMutableList.prototype.contains_29;
  ArrayList.prototype.subList_5 = AbstractMutableList.prototype.subList_5;
  ArrayList.prototype.equals = AbstractMutableList.prototype.equals;
  ArrayList.prototype.hashCode = AbstractMutableList.prototype.hashCode;
  ArrayList.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  ArrayList.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  ArrayList.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  HashMap.prototype._get_keys__1 = AbstractMutableMap.prototype._get_keys__1;
  HashMap.prototype.checkIsMutable_11 = AbstractMutableMap.prototype.checkIsMutable_11;
  HashMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  HashMap.prototype.equals = AbstractMap.prototype.equals;
  HashMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  HashMap.prototype.isEmpty_28 = AbstractMap.prototype.isEmpty_28;
  HashMap.prototype.toString = AbstractMap.prototype.toString;
  EntrySet.prototype.toArray = AbstractCollection.prototype.toArray;
  EntrySet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  EntrySet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  EntrySet.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  EntrySet.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  EntrySet.prototype.equals = AbstractMutableSet.prototype.equals;
  EntrySet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  EntrySet.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  EntrySet.prototype.toString = AbstractCollection.prototype.toString;
  HashSet.prototype.equals = AbstractMutableSet.prototype.equals;
  HashSet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  HashSet.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  HashSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  HashSet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  HashSet.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  HashSet.prototype.toString = AbstractCollection.prototype.toString;
  HashSet.prototype.toArray = AbstractCollection.prototype.toArray;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  LinkedHashMap.prototype._get_entries__7 = HashMap.prototype._get_entries__7;
  LinkedHashMap.prototype._get_keys__1 = AbstractMutableMap.prototype._get_keys__1;
  LinkedHashMap.prototype.putAll_0 = AbstractMutableMap.prototype.putAll_0;
  LinkedHashMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  LinkedHashMap.prototype.equals = AbstractMap.prototype.equals;
  LinkedHashMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  LinkedHashMap.prototype.isEmpty_28 = AbstractMap.prototype.isEmpty_28;
  LinkedHashMap.prototype.toString = AbstractMap.prototype.toString;
  ChainEntry.prototype.equals = SimpleEntry.prototype.equals;
  ChainEntry.prototype.hashCode = SimpleEntry.prototype.hashCode;
  ChainEntry.prototype.toString = SimpleEntry.prototype.toString;
  ChainEntry.prototype._get_key__3 = SimpleEntry.prototype._get_key__3;
  ChainEntry.prototype._get_value__3 = SimpleEntry.prototype._get_value__3;
  EntrySet_0.prototype.toArray = AbstractCollection.prototype.toArray;
  EntrySet_0.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  EntrySet_0.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  EntrySet_0.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  EntrySet_0.prototype.equals = AbstractMutableSet.prototype.equals;
  EntrySet_0.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  EntrySet_0.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  EntrySet_0.prototype.toString = AbstractCollection.prototype.toString;
  LinkedHashSet.prototype._get_map__0 = HashSet.prototype._get_map__0;
  LinkedHashSet.prototype.add_18 = HashSet.prototype.add_18;
  LinkedHashSet.prototype.contains_29 = HashSet.prototype.contains_29;
  LinkedHashSet.prototype.isEmpty_28 = HashSet.prototype.isEmpty_28;
  LinkedHashSet.prototype.iterator_42 = HashSet.prototype.iterator_42;
  LinkedHashSet.prototype._get_size__29 = HashSet.prototype._get_size__29;
  LinkedHashSet.prototype.equals = AbstractMutableSet.prototype.equals;
  LinkedHashSet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  LinkedHashSet.prototype.addAll_10 = AbstractMutableCollection.prototype.addAll_10;
  LinkedHashSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  LinkedHashSet.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  LinkedHashSet.prototype.toString = AbstractCollection.prototype.toString;
  LinkedHashSet.prototype.toArray = AbstractCollection.prototype.toArray;
  KClassImpl.prototype._get_simpleName__2 = KClass.prototype._get_simpleName__2;
  PrimitiveKClassImpl.prototype._get_jClass__2 = KClassImpl.prototype._get_jClass__2;
  PrimitiveKClassImpl.prototype.hashCode = KClassImpl.prototype.hashCode;
  PrimitiveKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  NothingKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  SimpleKClassImpl.prototype._get_jClass__2 = KClassImpl.prototype._get_jClass__2;
  SimpleKClassImpl.prototype.equals = KClassImpl.prototype.equals;
  SimpleKClassImpl.prototype.hashCode = KClassImpl.prototype.hashCode;
  SimpleKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  _no_name_provided__35.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__35.prototype.contains_29 = AbstractCollection.prototype.contains_29;
  _no_name_provided__35.prototype.containsAll_22 = AbstractCollection.prototype.containsAll_22;
  _no_name_provided__35.prototype.isEmpty_28 = AbstractCollection.prototype.isEmpty_28;
  _no_name_provided__35.prototype.toString = AbstractCollection.prototype.toString;
  RElementBuilder.prototype._get_childList__1 = RBuilder.prototype._get_childList__1;
  RElementBuilder.prototype.child_7 = RBuilder.prototype.child_7;
  RElementBuilder.prototype.child_8 = RBuilder.prototype.child_8;
  RElementBuilder.prototype.child_9 = RBuilder.prototype.child_9;
  RElementBuilder.prototype.child_10 = RBuilder.prototype.child_10;
  RElementBuilder.prototype.invoke_59 = RBuilder.prototype.invoke_59;
  RElementBuilder.prototype.children_6 = RBuilder.prototype.children_6;
  RElementBuilder.prototype.children_7 = RBuilder.prototype.children_7;
  RComponent.prototype.render_2 = RComponent.prototype.render_2;
  StringAttribute.prototype.get_24 = Attribute.prototype.get_24;
  StringAttribute.prototype.set_7 = Attribute.prototype.set_7;
  StringSetAttribute.prototype.get_24 = Attribute.prototype.get_24;
  StringSetAttribute.prototype.set_7 = Attribute.prototype.set_7;
  EnumAttribute.prototype.get_24 = Attribute.prototype.get_24;
  EnumAttribute.prototype.set_7 = Attribute.prototype.set_7;
  StringEncoder.prototype.empty_2 = AttributeEncoder.prototype.empty_2;
  EnumEncoder.prototype.empty_2 = AttributeEncoder.prototype.empty_2;
  InputType.prototype.compareTo_2 = Enum.prototype.compareTo_2;
  InputType.prototype.equals = Enum.prototype.equals;
  InputType.prototype.hashCode = Enum.prototype.hashCode;
  InputType.prototype.toString = Enum.prototype.toString;
  DIV.prototype._get_tagName__5 = HTMLTag.prototype._get_tagName__5;
  DIV.prototype._get_attributes__5 = HTMLTag.prototype._get_attributes__5;
  DIV.prototype._get_attributesEntries__5 = HTMLTag.prototype._get_attributesEntries__5;
  FIELDSET.prototype._get_tagName__5 = HTMLTag.prototype._get_tagName__5;
  FIELDSET.prototype._get_attributes__5 = HTMLTag.prototype._get_attributes__5;
  FIELDSET.prototype._get_attributesEntries__5 = HTMLTag.prototype._get_attributesEntries__5;
  INPUT.prototype._get_tagName__5 = HTMLTag.prototype._get_tagName__5;
  INPUT.prototype._get_attributes__5 = HTMLTag.prototype._get_attributes__5;
  INPUT.prototype._get_attributesEntries__5 = HTMLTag.prototype._get_attributesEntries__5;
  LEGEND.prototype._get_tagName__5 = HTMLTag.prototype._get_tagName__5;
  LEGEND.prototype._get_attributes__5 = HTMLTag.prototype._get_attributes__5;
  LEGEND.prototype._get_attributesEntries__5 = HTMLTag.prototype._get_attributesEntries__5;
  LABEL.prototype._get_tagName__5 = HTMLTag.prototype._get_tagName__5;
  LABEL.prototype._get_attributes__5 = HTMLTag.prototype._get_attributes__5;
  LABEL.prototype._get_attributesEntries__5 = HTMLTag.prototype._get_attributesEntries__5;
  RDOMBuilder.prototype._get_childList__1 = RBuilder.prototype._get_childList__1;
  RDOMBuilder.prototype.child_7 = RBuilder.prototype.child_7;
  RDOMBuilder.prototype.child_8 = RBuilder.prototype.child_8;
  RDOMBuilder.prototype.child_9 = RBuilder.prototype.child_9;
  RDOMBuilder.prototype.child_10 = RBuilder.prototype.child_10;
  RDOMBuilder.prototype.unaryPlus_0 = RBuilder.prototype.unaryPlus_0;
  RDOMBuilder.prototype.invoke_59 = RBuilder.prototype.invoke_59;
  RDOMBuilder.prototype.children_6 = RBuilder.prototype.children_6;
  RDOMBuilder.prototype.children_7 = RBuilder.prototype.children_7;
  Stress.prototype.compareTo_2 = Enum.prototype.compareTo_2;
  Stress.prototype.equals = Enum.prototype.equals;
  Stress.prototype.hashCode = Enum.prototype.hashCode;
  Stress.prototype.toString = Enum.prototype.toString;
  Foot.prototype.compareTo_2 = Enum.prototype.compareTo_2;
  Foot.prototype.equals = Enum.prototype.equals;
  Foot.prototype.hashCode = Enum.prototype.hashCode;
  Foot.prototype.toString = Enum.prototype.toString;
  Meter.prototype._get_name__0 = Enum.prototype._get_name__0;
  Meter.prototype.compareTo_2 = Enum.prototype.compareTo_2;
  Meter.prototype.equals = Enum.prototype.equals;
  Meter.prototype.hashCode = Enum.prototype.hashCode;
  Meter.prototype.toString = Enum.prototype.toString;
  ScansioniserUI.prototype.init = RComponent.prototype.init;
  ScansioniserUI.prototype.init_0 = RComponent.prototype.init_0;
  ScansioniserUI.prototype.children_8 = RComponent.prototype.children_8;
  ScansioniserUI.prototype.children_9 = RComponent.prototype.children_9;
  ScansioniserUI.prototype.render_3 = RComponent.prototype.render_3;
  _stableSortingIsSupported = null;
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  emptyMap_0 = emptyMap();
  attributeStringString = new StringAttribute();
  attributeSetStringStringSet = new StringSetAttribute();
  attributeInputTypeEnumInputTypeValues = new EnumAttribute(inputTypeValues);
  inputTypeValues = inputTypeValues$init$();
  events = listOf(['onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onError', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency', 'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding', 'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className', 'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords', 'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download', 'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang', 'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType', 'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth', 'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted', 'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role', 'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start', 'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width', 'wmode', 'wrap']);
  attrsMap = attrsMap$init$();
  key$delegate = StringAttr_getInstance();
  defaultValue$delegate = StringAttr_getInstance();
  defaultValue$delegate_0 = StringAttr_getInstance();
  value$delegate = StringAttr_getInstance();
  globalStylesCounter = 0;
  _.ScansioniserUI = ScansioniserUI;
  main();
  return _;
}));
